import {Component, ElementRef, EventEmitter, Inject, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {ConfService} from '../conf.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MAT_DIALOG_DATA, MatDialog, MatSnackBar} from '@angular/material';
import {map, startWith} from 'rxjs/operators';
import {AttributeDescriptionComponent, CrudapiComponent, EntityVersions, ICategory, MethodTypes} from '../crudapi/crudapi.component';
import {Location} from '@angular/common';
import {ConnecttocrudService} from '../connecttocrud.service';
import {AppComponent} from '../app.component';
import {SecureApiConfirmationComponent} from '../manage-entities/manage-entities.component';
import {KongService} from '../kong.service';
import {ListenerService} from '../listener.service';
import {DialogComponent} from '../shared/dialog/dialog.component';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../leftpanel/leftpanel.component';
import {DataaccessListenerService} from '../dataaccess-listener.service';
import {EntityVersionChangeConfirmationComponent} from '../edit-entity/edit-entity.component';
import {ApimanagementComponent} from '../apimanagement/apimanagement.component';
import {WebsocketService} from '../websocket.service';
import {TestReportComponent} from '../testsuite/test-report/test-report.component';
import {DependencyCheckComponent} from '../new-blockly/new-blockly.component';
import {AccountInfoService} from '../user/account-info.service';
import {ResponseSettingsComponent} from '../devex/api1/api1-executor/api1-executor.component';

export interface User {
    display: string;
}

declare let $;
const incr = 5;

@Component({
    selector: 'app-edit-entity-advanced',
    templateUrl: './edit-entity-advanced.component.html',
    styleUrls: ['./edit-entity-advanced.component.scss']
})
export class EditEntityAdvancedComponent implements OnInit, OnDestroy {
    content = false;
    myControl = new FormControl();
    entityName: string;
    displayName: string;
    description: string;
    required: boolean;
    progress = 0;
    Blocks = [];
    destroy: any;
    BlockList = {
        '1': 0,
        '2': 25,
        '3': 50,
        '4': 75,
        '5': 100
    };
    progressMessage: string;
    scope = [{'displayName': 'Public', 'value': 'public'},
        {'displayName': 'Private', 'value': 'private'}];
    cloneOptions = [{'displayName': 'Clone API as defined above (No Data will be imported)', 'value': 'clone'},
        {'displayName': 'Clone API with Data Imported (No change in original schema)', 'value': 'cloneWithData'}];
    cloneOptionSelected = 'clone';
    ispublished = false;
    @Input() databases: any;
    datatypes: any;
    @Input() dataTypeFilter: any;
    selectDatatype: string;
    selectedDatatypeFilter: string;
    isSelectedDatabaseNatureNoSQL: any;
    attributeName: string;
    attributetd: any;
    loading = false;
    trs: any;
    checkData: any;
    selectedDatatype = 'none';
    save: boolean;
    @Input() items: any;
    @Input() showBreadcrumb = true;
    flag: any;
    flagValue = true;
    cloneEnable: boolean;
    filteredOptions: Observable<ICategory[]>;
    options: any;
    cloneSave: boolean;
    url = environment.apihost;
    gatewayUrl: any;
    //= (this.partner === this.account ? 'https://gateway.' + this.partner + '.apiplatform.io' : 'https://gateway.' + this.partner + '.' + this.account + '.apiplatform.io');
    attributes = ['None', 'Primary', 'Unique'];
    type = ['none', 'change', 'rename', 'drop'];
    datastoragepolicy = ['None', 'Encrypted'];
    apiaccesspolicy = ['None', 'Decrypted', 'Encrypted', 'Masked (All with X)', 'Masked (All with x)', 'Masked (All with *)', 'Masked (xxxx-xxxx-xxxx-####)', 'Masked (xxxxxxxxxxxx####)'];
    displaypolicy = ['None', 'Decrypted', 'Encrypted', 'Masked'];
    data = ['String',
        'Integer',
        'Date',
        'Double',
        'Timestamp',
        'Boolean',
        'Array',
        'Object',
        'ObjectId'
    ];
    account = new FormControl();
    entityVersions: EntityVersions[] = [
        {name: 'v1'},
        {name: 'v2'},
        {name: 'v3'},
        {name: 'v4'}
    ];
    @Input() methodType = [];
    methodTypes: MethodTypes[] = [
        {id: 'GET', itemName: 'GET'},
        {id: 'PUT', itemName: 'PUT'},
        {id: 'POST', itemName: 'POST'},
        {id: 'DELETE', itemName: 'DELETE'},
        {id: 'PATCH', itemName: 'PATCH'}
    ];
    selectGateway = 'default';
    gateways = [
        {
            gateway_name: 'default',
            gateway_type: 'apiplatform'
        }
    ];
    settings = {
        text: 'Select Method Types',
        badgeShowLimit: 5,
        // selectAllText: 'Select All',
        // unSelectAllText: 'Unselect All',
        enableSearchFilter: true,
        autoPosition: false
    };
    @Input() accounts = ['default'];
    @Input() partner = localStorage.getItem('partner');
    @Input() entity: string;
    @Input() version: string;
    tableName: string;
    tableLabelName = 'Table Name';
    showNextPanel = false;
    SaveEntityCheck: boolean;
    routerLink: any;
    APILoading = false;
    buttonClick = false;
    accept = false;
    changeFlag: any;
    partnerKey = localStorage.getItem('partnerKey');
    @Input() account_id = localStorage.getItem('account');
    apiKey = localStorage.getItem('apikey');
    @Input() inputMetaSchema: any;
    @Input() apiByDefinition: any;
    // entities: any;
    // entityTypes = [];
    @Input() showSaveButton = true;
    entityAndVersion: any;

    origEntity: string;
    origVersion: string;
    origCollection: string;
    origMethods = [];
    previouslyDeployedData: any;
    previousSavedData: any;
    partnerEntities: any;
    partnerExecutors: any;
    isAPIAlreadyPresent: boolean;
    componentLoading = true;
    isAPIAlreadyPresentCheckCompleted = false;
    previouslyCheckedName: any;
    previouslyCheckedVersion: any;
    methods = [];
    collectionTypes = [{'displayName': 'Create New Collection', 'value': 'new'}, {
        'displayName': 'Use Existing Collection',
        'value': 'existing'
    }];
    collectionTypeSelected = 'new';
    @Input() showButtons = true;
    isHavingInputSchema = false;
    @Input() shouldConsiderAccountPermission = false;
    fromHistory = false;
    currentMessage: any;
    logTimeStamp: any;
    refreshLogCount = 0;
    logVisible = false;
    showDialogOnNonWebsocketConnection: any;
    apitype = 'DATAACCESS';
    connection: any;
    action: any;
    @Input() inputFieldsDisabled = true;
    @Input() fromCopyOrPromote = false;
    @Input() targetDatabases: any;
    @Output() onSavingEntity: EventEmitter<any> = new EventEmitter<any>();
    scopeSelected = 'public';
    selectedAPIGateway: any;
    selectedAPIGatewayName: any;
    APIGateways: any;

    apiGateways: any;
    gatewayControl = new FormControl([]);

    settingsData: any;
    selection: any;

    dependencyApis: any;
    testLoading = false;
    testSuiteResponse: any;

    constructor(private location: Location,
                public dialog: MatDialog,
                private router: Router,
                private confPost: ConfService,
                private _service: ConnecttocrudService,
                private route: ActivatedRoute,
                private appComp: AppComponent,
                private elementRef: ElementRef,
                private leftPanelDataListener: ListenerService,
                public platform: LeftpanelComponent,
                public accountInfoService: AccountInfoService,
                private dataAccessListenerInstance: DataaccessListenerService,
                public listenerServiceInstance: ListenerService,
                public apigatewayInstance: ApimanagementComponent,
                private kongService: KongService,
                private websocketService: WebsocketService) {
    }

    emitMethodType() {
        const methodTypes = [];
        this.methodType.forEach(method => {
            methodTypes.push(method.id);
        });
        this.methods = JSON.parse(JSON.stringify(methodTypes));
        this.apigatewayInstance.methodTypeListener.emit({
            methodType: this.methods,
            entityName: this.entityName,
            version: this.version,
            idEdit: true
        });
    }

    async ngOnInit() {
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }
        this.appComp.currentPageTitle = 'Edit Data Access API';
        // this.gatewayUrl = (localStorage.getItem('partner') === localStorage.getItem('account') ? 'https://gateway.' + localStorage.getItem('partner') + '.apiplatform.io' : 'https://gateway.' + localStorage.getItem('account') + '.' + localStorage.getItem('partner') + '.apiplatform.io');
        this.gatewayUrl = (localStorage.getItem('partner') === localStorage.getItem('account') ? 'https://' + localStorage.getItem('partner') + '.gateway.apiplatform.io' : 'https://' + localStorage.getItem('partner') + '.' + localStorage.getItem('account') + '.' + 'gateway.apiplatform.io');
        // if (!this.databases) {}
        // this.confPost.getDatabases(localStorage.getItem('partner')).subscribe(data => {
        //     this.databases = data;
        // });
        // this.progressMessage = 'Setting up your Account';
        this.router.events.subscribe((val) => {
            if (this.location.path() !== '') {
                this.routerLink = this.location.path();
                if (this.routerLink.includes('/entity/edit?partner=templates') || this.routerLink.includes('/entity/edit?partner=commons')) {
                    this.SaveEntityCheck = false;
                } else {
                    this.SaveEntityCheck = true;
                }
            }
        });

        if (this.platform.apiGateways !== null && this.platform.apiGateways !== undefined) {
            this.apiGateways = this.platform.apiGateways;
        } else {
            await this.confPost.getPartnerSettings(localStorage.getItem('partner'), localStorage.getItem('account'), localStorage.getItem('partnerKey')).toPromise().then(data => {
                    let resp: any;
                    resp = data;
                    this.apiGateways = resp['apigateway'];
                    this.platform.apiGateways = resp['apigateway'];
                },
                error => {
                    this.platform.handleErrorGracefully(error, 'Error while getting list of API Gateways. Please try again after sometime.');
                });
        }

        this.selection = this.platform.defaultGatewaySettings;
        const temp = localStorage.getItem('partner').split('-');
        let partnerShortCode = '';
        let env = '';
        if (temp.length > 1) {
            partnerShortCode = temp[temp.length - 1];
            env = temp[0];
        } else {
            partnerShortCode = temp[0];
            env = 'prod';
        }
        const isEnvironmentPresentInAdmin = false;
        const envInAdminCount = 0;
        if (this.platform.settingsData !== null && this.platform.settingsData !== undefined && this.platform.settingsData !== '') {
            this.settingsData = this.platform.settingsData;
            this.getDefaultGatewaySettings(this.settingsData);
        } else {
            this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), false).subscribe(settingsData => {
                if (settingsData['body'] && settingsData['body'][0]) {
                    this.settingsData = settingsData;
                    this.getDefaultGatewaySettings(this.settingsData);
                }
            }, error => {
                this.platform.handleErrorGracefully(error, 'Error while retrieving settings data. Please try again after sometime.');
            });
        }

        // this.getEntitiesForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account'));
        // await this.confPost.getCategoriesForPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
        //     this.options = data;
        //     this.filteredOptions = this.myControl.valueChanges
        //         .pipe(
        //             startWith<string | ICategory>(''),
        //             map(value => typeof value === 'string' ? value : value.name),
        //             map(name => name ? this._filter(name) : this.options.slice())
        //         );
        // });

        // New Implementation but commented
        // if (this.platform.partnerCategories !== null && this.platform.partnerCategories !== undefined) {
        //     this.options = this.platform.partnerCategories;
        // } else {
        //     await this.platform.getCategoriesForPartnerAccount();
        //     this.options = this.platform.partnerCategories;
        // }
        // this.filteredOptions = this.myControl.valueChanges
        //     .pipe(
        //         startWith<string | ICategory>(''),
        //         map(value => typeof value === 'string' ? value : value.name),
        //         map(name => name ? this._filter(name) : this.options.slice())
        //     );


        // const getEntityNameAndVersionAsCustomType = new Promise(async (resolve, reject) => {
        //     if (this.platform.entityAndVersion !== null && this.platform.entityAndVersion !== undefined) {
        //         this.entityAndVersion = this.platform.entityAndVersion;
        //         resolve('success');
        //     } else {
        //         await this.confPost.getEntityNameAndVersionAsCustomType(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(response => {
        //                 if (response.status === 200) {
        //                     this.entityAndVersion = response.body['entityNameAndVersion'];
        //                     this.platform.entityAndVersion = this.entityAndVersion;
        //                     resolve('success');
        //                 } else {
        //                     resolve('failed');
        //                 }
        //             },
        //             error => {
        //                 this.platform.openSnackBar('Error while getting entity name and version for partner account: ' + error.error.message, 'Error', {
        //                     duration: 15000,
        //                     verticalPosition: 'top',
        //                     horizontalPosition: 'center'
        //                 });
        //                 resolve('failed');
        //             });
        //     }
        // });

        const getEntitiesForPartnerAccount = new Promise(async (resolve, reject) => {
            if (this.platform.partnerEntities !== null && this.platform.partnerEntities !== undefined) {
                this.partnerEntities = this.platform.partnerEntities;
                resolve('success');
            } else {
                await this.confPost.getEntitiesForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).toPromise().then(data1 => {
                    if (data1 && data1 !== undefined && data1 !== null) {
                        this.partnerEntities = data1;
                        this.platform.partnerEntities = this.partnerEntities;
                        resolve('success');
                    } else {
                        resolve('failed');
                        this.platform.openSnackBar('Error while retrieving data access entities for your account', 'Error', {
                            duration: 30000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }
                }, error => {
                    resolve('failed');
                    this.platform.openSnackBar('Error while retrieving data access entities for your account', 'Error', {
                        duration: 30000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
            }
        });

        const getApiExecutorsByPartnerAccount = new Promise((resolve, reject) => {
            if (this.platform.leftpanelData !== null && this.platform.leftpanelData !== undefined) {
                this.partnerExecutors = this.platform.leftpanelData;
                resolve('success');
            } else {
                this.confPost.getApiExecutorsByPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account'), 'partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account') + '&fields=executor_name,executor_version,executor_method_type,executor_type,executor_scope,executor_display_name,executor_category,service_provider,apiUrl,published,scopeOfAccess,registeredAsIs,creationTime,lastModifiedTime,executor_description,isMockResponseEnabled,mockResponses,id').toPromise().then(data => {
                    if (data && data !== null && data !== undefined) {
                        this.partnerExecutors = data;
                        this.platform.leftpanelData = data;
                        resolve('success');
                    } else {
                        resolve('failed');
                        this.platform.openSnackBar('Error while retrieving API executors for your account', 'Error', {
                            duration: 30000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }
                }, error => {
                    resolve('failed');
                    this.platform.openSnackBar('Error while retrieving API executors for your account', 'Error', {
                        duration: 30000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
            }
        });

        // Promise.all([getEntityNameAndVersionAsCustomType]).then(resp => {
        //     this.componentLoading = false;
        // });

        this.route.queryParams
            .subscribe(async params => {
                this.fromHistory = false;
                if (params.timestamp && params.timestamp !== null && params.timestamp !== undefined && params.timestamp !== '') {
                    this.fromHistory = true;
                    this.confPost.getData('services', 'services', 'v1', 'apiHistory', 'partner=' + params.partner + '&account=' + params.account + '&at=' + params.timestamp).subscribe(response => {
                        if (response && response !== null && response !== undefined && response[0] && response[0]['executor']) {
                            this.apiByDefinition = response[0]['executor'];
                            this.checkData = JSON.parse(JSON.stringify(response[0]['executor']));
                            if (this.apiByDefinition.database !== 'default') {
                                for (let i = 0; i < this.apiByDefinition.attributes.length; i++) {
                                    this.apiByDefinition.attributes[i]['updateOption'] = 'none';
                                }
                            }
                            this.items = response[0]['executor'];
                            this.origEntity = response[0]['executor']['entityname'];
                            this.origVersion = response[0]['executor']['version'];
                            if (this.items.methods && this.items.methods.length > 0) {
                                this.methodType = [];
                                this.methods = this.items.methods;
                                this.items.methods.forEach(method => {
                                    this.methodType.push({'id': method, 'itemName': method});
                                });
                                // this.methodType = this.items.methods;
                                // this.origMethods = this.items.methods;
                            } else {
                                this.methodType = this.methodTypes;
                                const methodTypes = [];
                                this.methodType.forEach(method => {
                                    methodTypes.push(method.id);
                                });
                                this.methods = methodTypes;
                            }

                            const gateways = [];

                            if (this.items['gatewaySettings']) {
                                if (this.items['gatewaySettings'].length > 0) {
                                    for (const gateway of this.items['gatewaySettings']) {
                                        gateways.push(gateway['name']);
                                    }
                                }
                            }
                            if (gateways.length === 0) {
                                gateways.push('default');
                            }
                            this.gatewayControl.setValue(gateways);

                            if (this.apiByDefinition.hasOwnProperty('tableCreation')) {
                                if (this.apiByDefinition['tableCreation'] === true) {
                                    this.collectionTypeSelected = 'new';
                                } else {
                                    this.collectionTypeSelected = 'existing';
                                }
                            } else {
                                this.collectionTypeSelected = 'new';
                            }

                            if (this.apiByDefinition.hasOwnProperty('referentialKeyConstraints')) {
                                if (this.apiByDefinition['referentialKeyConstraints'] === null || this.apiByDefinition['referentialKeyConstraints'] === undefined) {
                                    this.apiByDefinition['referentialKeyConstraints'] = [];
                                }
                            } else {
                                this.apiByDefinition['referentialKeyConstraints'] = [];
                            }
                            this.origCollection = this.items['tableName'];
                            this.content = true;
                            this.ispublished = this.items['published'];
                            this.filterDataTypes(this.items.database);
                            if (this.partner === 'commons' || this.partner === 'templates') {
                                this.cloneEnable = true;
                            }
                        } else {
                            this.platform.openSnackBar('Error in retrieving the history for this API', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        }
                    }, error => {
                        this.platform.openSnackBar('Error in retrieving the history for this API', 'Error', {
                            duration: 5000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    });
                } else {
                    if (this.inputMetaSchema === null || this.inputMetaSchema === undefined || this.inputMetaSchema === '') {
                        this.partner = params.partner;
                        this.accounts = params.account;
                        this.entity = params.entity;
                        this.entityName = params.entity;
                        this.version = params.version;
                        this.origEntity = params.entity;
                        this.origVersion = params.version;
                        await this.getEntity(this.partner, this.accounts, this.entity, this.version);
                    } else {
                        this.isHavingInputSchema = true;
                        this.apiByDefinition = JSON.parse(JSON.stringify(this.inputMetaSchema));
                        this.items = JSON.parse(JSON.stringify(this.inputMetaSchema));
                        this.origEntity = this.apiByDefinition['entityname'];
                        this.origVersion = this.apiByDefinition['version'];
                        this.inputMetaSchema = null;
                    }
                    // this.apiByDefinition = data;
                    // this.items = data;
                    if (this.apiByDefinition && this.apiByDefinition !== null && this.apiByDefinition !== undefined) {
                        this.previouslyDeployedData = {
                            'entityname': this.apiByDefinition['entityname'],
                            'category': this.apiByDefinition['category'],
                            'version': this.apiByDefinition['version'],
                            'displayname': this.apiByDefinition['displayname'],
                            'description': this.apiByDefinition['description'],
                            'scopeOfAccess': this.apiByDefinition['scopeOfAccess'],
                            'database': this.apiByDefinition['database'],
                            'methods': this.apiByDefinition['methods'],
                            'tableName': this.apiByDefinition['tableName'],
                            'published': this.apiByDefinition['published'],
                            'attributes': this.apiByDefinition.attributes,
                            'apiResponses': this.apiByDefinition['apiResponses'],
                            'gatewayManagers': this.apiByDefinition['gatewayManagers'],
                            'gatewaySettings': this.apiByDefinition['gatewaySettings']
                        };

                        const gateways = [];

                        if (this.items['gatewaySettings']) {
                            if (this.items['gatewaySettings'].length > 0) {
                                for (const gateway of this.items['gatewaySettings']) {
                                    gateways.push(gateway['name']);
                                }
                            }
                        }
                        if (gateways.length === 0) {
                            gateways.push('default');
                        }
                        this.gatewayControl.setValue(gateways);

                        if (this.apiByDefinition.hasOwnProperty('tableCreation')) {
                            if (this.apiByDefinition['tableCreation'] === true) {
                                this.collectionTypeSelected = 'new';
                            } else {
                                this.collectionTypeSelected = 'existing';
                            }
                        } else {
                            this.collectionTypeSelected = 'new';
                        }

                        if (this.apiByDefinition.hasOwnProperty('apiResponses') && this.apiByDefinition.apiResponses === null && this.apiByDefinition.methods !== null) {
                            this.apiByDefinition['apiResponses'] = [];
                            for (const method of this.apiByDefinition.methods) {
                                if (method) {
                                    if ((this.apiByDefinition['apiResponses'].filter(element => element.method === method)).length === 0) {
                                        if (method === 'PUT' || method === 'PATCH' || method === 'POST') {
                                            this.apiByDefinition['apiResponses'].push({
                                                method: method,
                                                apiResponseDetails: [],
                                                payloadAsResponse: false,
                                                description: '',
                                                schemaValidation: true,
                                                content: [],
                                                mockResponses: []
                                            });
                                        } else if (method === 'GET') {
                                            this.apiByDefinition['apiResponses'].push({method: method, apiResponseDetails: [], description: '', content: [],mockResponses: []});
                                        } else {
                                            this.apiByDefinition['apiResponses'].push({method: method, apiResponseDetails: [], description: '', content: [],mockResponses: []});
                                        }
                                    }
                                }
                            }
                        }


                        if (this.apiByDefinition.hasOwnProperty('referentialKeyConstraints')) {
                            if (this.apiByDefinition['referentialKeyConstraints'] === null || this.apiByDefinition['referentialKeyConstraints'] === undefined) {
                                this.apiByDefinition['referentialKeyConstraints'] = [];
                            }
                        } else {
                            this.apiByDefinition['referentialKeyConstraints'] = [];
                        }
                        this.previouslyDeployedData['referentialKeyConstraints'] = this.apiByDefinition['referentialKeyConstraints'];
                        this.previouslyDeployedData = JSON.parse(JSON.stringify(this.previouslyDeployedData));
                        // this.checkData = JSON.parse(JSON.stringify(data));
                        this.checkData = JSON.parse(JSON.stringify(this.apiByDefinition));
                        if (this.items.methods && this.items.methods !== null && this.items.methods !== undefined && this.items.methods.length > 0) {
                            this.methodType = [];
                            this.items.methods.forEach(method => {
                                this.methodType.push({'id': method, 'itemName': method});
                            });
                            this.methods = JSON.parse(JSON.stringify(this.items.methods));
                            // this.methodType = this.items.methods;
                            // this.origMethods = this.items.methods;
                        } else {
                            if (this.inputFieldsDisabled) {
                                this.methodType = JSON.parse(JSON.stringify(this.methodTypes));
                                const methodTypes = [];
                                this.methodType.forEach(method => {
                                    methodTypes.push(method.id);
                                });
                                this.methods = JSON.parse(JSON.stringify(methodTypes));
                            }

                        }
                        this.origCollection = this.items['tableName'];
                        this.content = true;
                        this.ispublished = this.items['published'];
                        await this.filterDataTypes(this.items.database);
                        if (this.isHavingInputSchema === true) {
                            if (this.selectedDatatypeFilter && this.selectedDatatypeFilter === 'mongodb') {
                                for (const attribute of this.apiByDefinition['attributes']) {
                                    if (attribute) {
                                        if (attribute['customType'] === true) {
                                            if (this.dataTypeFilter.filter((element) => element['type'] === attribute['type']).length === 0) {
                                                this.dataTypeFilter.push({
                                                    'data_types': [{
                                                        'type': attribute['type'],
                                                        'default_length': '',
                                                        'min_length': '',
                                                        'max_length': ''
                                                    }],
                                                    'database_type': this.selectedDatatypeFilter
                                                });
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        if (this.partner === 'commons' || this.partner === 'templates') {
                            this.cloneEnable = true;
                        }
                        if (this.isSelectedDatabaseNatureNoSQL === false) {
                            for (let i = 0; i < this.apiByDefinition.attributes.length; i++) {
                                this.apiByDefinition.attributes[i]['updateOption'] = 'none';
                            }
                        }
                    }
                }
            });

        $(document).on('click', '.removeAttribute', function () {
            if ($(this).parent('td').closest('tr').next('table').length) {
                $(this).parent('td').closest('tr').next('table').remove();
            }
            $(this).parent('td').closest('tr').remove();
        });
        this.componentLoading = false;
    }

    hasViewPagePermissions() {
        if (this.isHavingInputSchema && !this.shouldConsiderAccountPermission) {
            return this.platform.hasPlatformPermission('EDIT_DATA_ACCESS_API_ADVANCED');
        } else {
            if (this.fromHistory === true) {
                return (this.platform.hasPermissions(['EDIT_HISTORY', 'EDIT_DATA_ACCESS_API_ADVANCED', 'edit:' + this.partner + '=>' + this.account_id + '=>' + this.origEntity + '=>' + this.origVersion]));
            } else {
                return this.platform.hasPermissions(['EDIT_DATA_ACCESS_API_ADVANCED', 'edit:' + this.partner + '=>' + this.account_id + '=>' + this.origEntity + '=>' + this.origVersion]);
            }
        }
    }

    hasSchemaPermission() {
        if (this.isHavingInputSchema === true) {
            return true;
        } else {
            return this.platform.hasPermissions(['DATA_STORAGE_DATA_ACCESS_API_ADVANCED', 'data_storage:' + this.partner + '=>' + this.account_id + '=>' + this.origEntity + '=>' + this.origVersion]);
        }
    }

    hasForeignKeyPermission() {
        if (this.isHavingInputSchema === true) {
            return (this.isSelectedDatabaseNatureNoSQL === false && this.apiByDefinition['referentialKeyConstraints'] && this.apiByDefinition['referentialKeyConstraints'] !== null && this.apiByDefinition['referentialKeyConstraints'] !== undefined);
        } else {
            return (this.isSelectedDatabaseNatureNoSQL === false && this.platform.hasPermissions(['FOREIGN_KEY_DATA_ACCESS_API_ADVANCED', 'foreign_key:' + this.partner + '=>' + this.account_id + '=>' + this.origEntity + '=>' + this.origVersion]) && this.apiByDefinition['referentialKeyConstraints'] && this.apiByDefinition['referentialKeyConstraints'] !== null && this.apiByDefinition['referentialKeyConstraints'] !== undefined);
        }
    }

    hasMethodDefinitionPermission() {
        if (this.isHavingInputSchema === true) {
            return true;
        } else {
            return (this.platform.hasPermissions(['METHOD_DEFINITION_DATA_ACCESS_API_ADVANCED', 'method_definition:' + this.partner + '=>' + this.account_id + '=>' + this.origEntity + '=>' + this.origVersion]) && this.apiByDefinition['apiResponses'] && this.apiByDefinition['apiResponses'] !== null && this.apiByDefinition['apiResponses'] !== undefined);
        }
    }

    hasCachePermission() {
        if (this.isHavingInputSchema === true) {
            return true;
        } else {
            return this.platform.hasPermissions(['CACHE_DATA_ACCESS_API_ADVANCED', 'cache:' + this.partner + '=>' + this.account_id + '=>' + this.origEntity + '=>' + this.origVersion]);
        }
    }

    getEntity(partner, account, entity, version) {
        return new Promise((resolve, reject) => {
            this.confPost.getEntity(partner, account, entity, version).subscribe(data => {
                this.apiByDefinition = data;
                this.items = data;
                resolve('success');
            }, error => {
                this.platform.handleErrorGracefully(error, 'Error while retrieving the API. Please try again afer sometime.');
                this.router.navigateByUrl('/controlplane');
                reject('failed');
            });
        });
    }

    changeType(def, i) {
        if (def['updateOption'] === 'rename') {
            if (this.checkData.attributes[i]) {
                this.apiByDefinition.attributes[i] = JSON.parse(JSON.stringify(this.checkData.attributes[i]));
                this.apiByDefinition.attributes[i]['updateOption'] = 'rename';
                this.apiByDefinition.attributes[i]['previousAttributeName'] = def['attributeName'];
            } else {
                this.apiByDefinition.attributes[i] = {
                    'customType': false,
                    'apiAccessPolicy': 'None',
                    'attributeName': null,
                    'type': null,
                    'array': false,
                    'size': null,
                    'precision': null,
                    'autoIncrement': false,
                    'defaultValue': null,
                    'attributeType': 'None',
                    'dataStoragePolicy': 'None',
                    'description': null,
                    'displayName': null,
                    'displayPolicy': null,
                    'updateOption': 'rename',
                    'required': false,
                    'subType': []
                };
                this.apiByDefinition.attributes[i]['previousAttributeName'] = this.apiByDefinition.attributes[i]['attributeName'];
            }
        } else if (def['updateOption'] === 'drop') {
            if (this.checkData.attributes[i]) {
                this.apiByDefinition.attributes[i] = JSON.parse(JSON.stringify(this.checkData.attributes[i]));
                this.apiByDefinition.attributes[i]['updateOption'] = 'drop';
            } else {
                this.apiByDefinition.attributes[i] = {
                    'customType': false,
                    'apiAccessPolicy': 'None',
                    'attributeName': null,
                    'type': null,
                    'array': false,
                    'size': null,
                    'precision': null,
                    'autoIncrement': false,
                    'defaultValue': null,
                    'attributeType': 'None',
                    'dataStoragePolicy': 'None',
                    'description': null,
                    'displayName': null,
                    'displayPolicy': null,
                    'updateOption': 'drop',
                    'required': false,
                    'subType': []
                };
            }
        } else if (def['updateOption'] === 'none') {
            if (this.checkData.attributes[i]) {
                this.apiByDefinition.attributes[i] = JSON.parse(JSON.stringify(this.checkData.attributes[i]));
                this.apiByDefinition.attributes[i]['updateOption'] = 'none';
            } else {
                this.apiByDefinition.attributes[i] = {
                    'customType': false,
                    'apiAccessPolicy': 'None',
                    'attributeName': null,
                    'type': null,
                    'array': false,
                    'size': null,
                    'precision': null,
                    'autoIncrement': false,
                    'defaultValue': null,
                    'attributeType': 'None',
                    'dataStoragePolicy': 'None',
                    'description': null,
                    'displayName': null,
                    'displayPolicy': null,
                    'updateOption': 'none',
                    'required': false,
                    'subType': []
                };
            }
        } else if (def['updateOption'] === 'change') {
            if (this.checkData.attributes[i]) {
                this.apiByDefinition.attributes[i] = JSON.parse(JSON.stringify(this.checkData.attributes[i]));
                this.apiByDefinition.attributes[i]['updateOption'] = 'change';
            } else {
                this.apiByDefinition.attributes[i] = {
                    'customType': false,
                    'apiAccessPolicy': 'None',
                    'attributeName': null,
                    'type': null,
                    'array': false,
                    'size': null,
                    'precision': null,
                    'autoIncrement': false,
                    'defaultValue': null,
                    'attributeType': 'None',
                    'dataStoragePolicy': 'None',
                    'description': null,
                    'displayName': null,
                    'displayPolicy': null,
                    'updateOption': 'change',
                    'required': false,
                    'subType': []
                };
            }
        }
    }

    typeCheck(definition, subType) {

        const entityAndVersionCheckString = definition.type,
            substring = '_';
        if (entityAndVersionCheckString.includes(substring)) {
            definition.customType = true;
            definition.attributeType = 'DBRef';
            definition.array = true;
        } else {
            definition.customType = false;
            definition.attributeType = 'None';
            definition.array = false;
        }

        if (this.items['database'] === 'default' || this.items['database'] === 'mongo') {
            if (definition.type === 'Array' || definition.type === 'Object') {
                this.addAttributeField(definition, subType, this.items['database']);
            } else {
                this.removeAttributeField(definition.subType);
            }
        } else {
            if (definition.type === 'Array' || definition.type === 'Object') {
                this.addAttributeField(definition, subType, this.items['database']);
            } else {
                this.removeAttributeField(definition.subType);
            }
        }
    }

    addAttributeField(parent, data, selectDB) {
        if (selectDB === 'mongodb' || selectDB === 'default') {
            const newField = {
                'customType': false,
                'apiAccessPolicy': 'None',
                'attributeName': null,
                'type': null,
                'array': false,
                'size': null,
                'precision': null,
                'autoIncrement': false,
                'defaultValue': null,
                'attributeType': 'None',
                'dataStoragePolicy': 'None',
                'description': null,
                'displayName': null,
                'displayPolicy': null,
                'required': false,
                'subType': []
            };
            if (this.isSelectedDatabaseNatureNoSQL === false) {
                newField['newlyAddedInSQL'] = true;
            }
            if (data == null) {
                parent.subType = [];
                parent.subType.push(newField);
            } else {
                data.push(newField);
            }
        } else {
            const newField = {
                'customType': false,
                'apiAccessPolicy': 'None',
                'attributeName': null,
                'type': null,
                'size': null,
                'precision': null,
                'autoIncrement': false,
                'defaultValue': null,
                'attributeType': 'None',
                'dataStoragePolicy': 'None',
                'description': null,
                'displayName': null,
                'displayPolicy': null,
                'required': false,
                'updateOption': 'none',
                'subType': [],
            };
            if (this.isSelectedDatabaseNatureNoSQL === false) {
                newField['newlyAddedInSQL'] = true;
            }
            if (data == null) {
                parent.subType = [];
                parent.subType.push(newField);
            } else {
                data.push(newField);
            }
        }
    }

    removeAttributeField(data) {
        for (var i = 0; i < data.length; i++) {
            data.splice(i, 1);
        }
    }

    removeAttribute(data, index) {
        if (confirm('Are you sure you want to remove this attribute?')) {
            data.splice(index, 1);
        }
    }

    setPrimaryFlag(i, type) {
        if (type === 'Primary' && this.flagValue) {
            this.flag = i;
            this.flagValue = false;
        } else if (i === this.flag && !this.flagValue && type !== 'Primary') {
            this.flag = null;
            this.flagValue = true;
        }
        if (type === 'Primary') {
            this.apiByDefinition.attributes[i]['required'] = true;
        } else {
            this.apiByDefinition.attributes[i]['required'] = false;
        }
    }

    displayFn(user?: ICategory): string | undefined {
        return user ? user.name : undefined;
    }

    getRegion(val) {
        return this.platform.getRegion(val);
    }

    // getEntitiesForPartnerAccount(partner, account) {
    //     this.confPost.getEntitiesForPartnerAccount(partner, account).subscribe(data => {
    //         this.entities = data;
    //         this.entities.forEach(entity => {
    //             this.entityTypes.push(entity.entityname + '_' + entity.version);
    //         });
    //     });
    // }

    omit_special_char(event) {
        let k;
        k = event.charCode;  //         k = event.keyCode;  (Both can be used)

        // return ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || k === 32 || (k >= 48 && k <= 57));
        return (k !== 95);
    }

    async filterDataTypes(val) {
        // if (this.apiByDefinition && this.apiByDefinition.attributes && this.apiByDefinition.database !== 'default') {
        if (this.apiByDefinition && this.apiByDefinition.attributes && this.isSelectedDatabaseNatureNoSQL === false) {
            for (let i = 0; i < this.apiByDefinition.attributes.length; i++) {
                this.apiByDefinition.attributes[i]['updateOption'] = 'none';
            }
        }
        if (this.platform.databases !== null && this.platform.databases !== undefined) {
            await this.platform.updateIsNoSQLForMongo(this.platform.databases);
            this.databases = this.platform.databases;
            this.databases.filter(items => {
                if (items.database_name === val) {
                    this.selectedDatatypeFilter = items.database_type;
                    if (items.hasOwnProperty('is_nosql')) {
                        this.isSelectedDatabaseNatureNoSQL = items.is_nosql;
                    }
                }
            });
        } else {
            await this.confPost.getDatabases(localStorage.getItem('partner')).toPromise().then(async databases => {
                    await this.platform.updateIsNoSQLForMongo(databases);
                    this.databases = this.platform.databases;
                    this.databases.filter(items => {
                        if (items.database_name === val) {
                            this.selectedDatatypeFilter = items.database_type;
                            if (items.hasOwnProperty('is_nosql')) {
                                this.isSelectedDatabaseNatureNoSQL = items.is_nosql;
                            }
                        }
                    });
                },
                error => {
                    this.platform.openSnackBar('Error while getting list of databases: ' + error.error.message, 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
        }
        if (this.platform.datatypes !== null && this.platform.datatypes !== undefined) {
            this.datatypes = this.platform.datatypes;
            this.dataTypeFilter = [];
            this.datatypes.filter(items => {
                if (items.database_type === this.selectedDatatypeFilter) {
                    this.dataTypeFilter.push(items);
                }
            });
            if (this.selectedDatatypeFilter && this.selectedDatatypeFilter === 'mongodb') {
                await this.platform.getCustomTypes(val);
                this.entityAndVersion = this.platform.entityAndVersion;
            } else {
                this.entityAndVersion = [];
            }
            if (this.entityAndVersion) {
                for (let i = 0; i < this.entityAndVersion.length; i++) {
                    const newType = {
                        'database_type': 'mongodb',
                        'data_types': [
                            {
                                'type': this.entityAndVersion[i],
                                'default_length': '',
                                'min_length': '',
                                'max_length': ''
                            }]
                    };
                    this.dataTypeFilter.push(newType);
                }
            }
            if (this.selectedDatatypeFilter === 'mongodb') {
                this.tableLabelName = 'Collection Name';
            } else {
                this.tableLabelName = 'Table Name';
            }
        } else {
            await this.confPost.getDataTypes().toPromise().then(async data => {
                    this.datatypes = data;
                    this.platform.datatypes = data;
                    this.dataTypeFilter = [];
                    this.datatypes.filter(items => {
                        if (items.database_type === this.selectedDatatypeFilter) {
                            this.dataTypeFilter.push(items);
                        }
                    });
                    if (this.selectedDatatypeFilter && this.selectedDatatypeFilter === 'mongodb') {
                        await this.platform.getCustomTypes(val);
                        this.entityAndVersion = this.platform.entityAndVersion;
                    } else {
                        this.entityAndVersion = [];
                    }
                    if (this.entityAndVersion) {
                        for (let i = 0; i < this.entityAndVersion.length; i++) {
                            const newType = {
                                'database_type': 'mongodb',
                                'data_types': [
                                    {
                                        'type': this.entityAndVersion[i],
                                        'default_length': '',
                                        'min_length': '',
                                        'max_length': ''
                                    }]
                            };
                            this.dataTypeFilter.push(newType);
                        }
                    }
                    if (this.selectedDatatypeFilter === 'mongodb') {
                        this.tableLabelName = 'Collection Name';
                    } else {
                        this.tableLabelName = 'Table Name';
                    }
                },
                error => {
                    this.platform.openSnackBar('Error while getting list of data types: ' + error.error.message, 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
        }

    }

    addAllMethodsToResponseConfigurations() {
        this.apiByDefinition['apiResponses'] = [];
        const methodTypes = [];
        this.methodType = [];
        this.methodTypes.forEach(method => {
            this.methodType.push(method);
        });
        this.methodType.forEach(method => {
            methodTypes.push(method.id);
        });
        this.methods = methodTypes;
        for (const method of this.methods) {
            if (method) {
                if ((this.apiByDefinition['apiResponses'].filter(element => element.method === method)).length === 0) {
                    if (method === 'PUT' || method === 'PATCH' || method === 'POST') {
                        this.apiByDefinition['apiResponses'].push({
                            method: method,
                            apiResponseDetails: [],
                            payloadAsResponse: false,
                            description: '',
                            schemaValidation: true,
                            content: [],
                            mockResponses: []
                        });
                    } else if (method === 'GET') {
                        this.apiByDefinition['apiResponses'].push({method: method, apiResponseDetails: [], description: '', content: [],mockResponses: []});
                    } else {
                        this.apiByDefinition['apiResponses'].push({method: method, apiResponseDetails: [], description: '', content: [],mockResponses: []});
                    }
                }
            }
        }
        this.apigatewayInstance.methodTypeListener.emit({
            methodType: this.methods,
            entityName: this.entityName,
            version: this.version,
            idEdit: true
        });
    }

    addMethodToResponseConfiguration(event) {
        if (this.apiByDefinition['apiResponses']) {
            if (event.id === 'PUT' || event.id === 'PATCH' || event.id === 'POST') {
                this.apiByDefinition['apiResponses'].push({
                    method: event.id,
                    apiResponseDetails: [],
                    payloadAsResponse: false,
                    description: '',
                    schemaValidation: true,
                    content: [],
                    mockResponses: []
                });
            } else if (event.id === 'GET') {
                this.apiByDefinition['apiResponses'].push({method: event.id, apiResponseDetails: [], description: '', content: [], mockResponses: []});
            } else {
                this.apiByDefinition['apiResponses'].push({method: event.id, apiResponseDetails: [], description: '', content: [], mockResponses: []});
            }
        }
    }

    removeMethodFromResponseConfiguration(event) {
        if (this.apiByDefinition['apiResponses']) {
            for (let i = 0; i < this.apiByDefinition['apiResponses'].length; i++) {
                if (this.apiByDefinition['apiResponses'][i] && this.apiByDefinition['apiResponses'][i] !== null && this.apiByDefinition['apiResponses'][i] !== undefined) {
                    if (this.apiByDefinition['apiResponses'][i]['method'] === event.id) {
                        this.apiByDefinition['apiResponses'].splice(i, 1);
                    }
                }
            }
        }
    }

    removeAllMethodsToResponseConfigurations() {
        this.apiByDefinition['apiResponses'] = [];
        this.methodType = [];
    }

    getDatabaseTypeForDatabaseName(val) {
        this.databases.filter(items => {
            if (items.database_name === val) {
                this.selectedDatatypeFilter = items.database_type;
            }
        });
    }


    displayFn1(user?: User): string | undefined {
        return user ? user.display : undefined;
    }

    closeLogPanel() {
        this.logVisible = false;
    }

    listenAPICreation(apiName, apiVersion, timestamp) {
        this.websocketService.listenAPICreation(localStorage.getItem('partner'), localStorage.getItem('account'), apiName, apiVersion, localStorage.getItem('sessionID'), timestamp, this.action).subscribe(data => {
            if (data) {
                this.currentMessage = JSON.parse(data.body);
            }
        });
    }

    async updateApiWithCore() {

        this.currentMessage = '';
        const timeStamp = Date.now();
        this.logTimeStamp = timeStamp;
        this.entityName = this.items['entityname'];
        this.version = this.items['version'];

        this.loading = true;
        this.logVisible = false;

        if (this.websocketService.isOpen()) {
            this.connection = true;
            // this.logVisible = true;
        } else {
            this.connection = false;
        }
        this.action = 'redeploy';
        this.entityName = this.entityName;
        this.version = this.version;
        this.listenAPICreation(this.entityName, this.version, timeStamp);

        const topic = localStorage.getItem('partner') + '.' + localStorage.getItem('account') + '.' + this.entityName + '.' + this.version + '.' + localStorage.getItem('sessionID') + '.' + timeStamp.toString() + '.' + this.action;

        const methods = [];
        this.methodType.forEach(method => {
            methods.push(method.id);
        });

        const gateways = this.gatewayControl.value as string[];
        const gatewaySettings = [];
        if (gateways && gateways.length > 0) {
            for (const gateway of gateways) {
                if (gateway) {
                    gatewaySettings.push({name: gateway});
                }
            }
        }

        if (this.items.entityname !== undefined && this.items.entityname !== null && this.items.entityname.length !== 0 &&
            this.items['version'] !== undefined && this.items['version'] !== null && this.items['version'].length !== 0 &&
            this.items['category'] !== undefined && this.items['category'] !== null && this.items['category'].length !== 0 &&
            this.items['database'] !== undefined && this.items['database'] !== null && this.items['database'].length !== 0) {
            if (methods !== undefined && methods !== null && methods.length !== 0) {
                if (gatewaySettings && gatewaySettings.length !== 0) {
                    const temparray = [];
                    for (let i = 0; i < this.apiByDefinition['attributes'].length; i++) {
                        if (this.apiByDefinition['attributes'][i]['attributeName'] !== null && this.apiByDefinition['attributes'][i]['type'] !== null) {
                            temparray.push(this.apiByDefinition['attributes'][i]);
                        }
                    }
                    this.apiByDefinition['attributes'] = temparray;
                    if (this.apiByDefinition['attributes'].length === 0) {
                        this.platform.openSnackBar('Please define schema under Schema Definition', 'Error', {
                            duration: 5000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    } else {
                        if (this.origEntity === this.items['entityname'] && this.origVersion === this.items['version']) {

                            const crudAPI = {
                                'entityname': this.items['entityname'],
                                'category': this.items['category'],
                                'version': this.items['version'],
                                'displayname': this.items['displayname'],
                                'description': this.items['description'],
                                'published': this.items['published'],
                                'scopeOfAccess': this.items['scopeOfAccess'],
                                'creationTime': this.items['creationTime'],
                                'lastModifiedTime': Date.now(),
                                'registeredAsIs': false,
                                'database': this.items['database'],
                                'methods': methods,
                                'tableName': this.items['tableName'] !== null ? this.items['tableName'] : this.account_id + '_' + this.items['entityname'] + '_' + this.items['version'],
                                'attributes': this.apiByDefinition.attributes,
                                'apiResponses': this.apiByDefinition['apiResponses'],
                                'referentialKeyConstraints': this.apiByDefinition['referentialKeyConstraints'],
                                'gatewayManagers': this.apiByDefinition['gatewayManagers'],
                                'gatewaySettings': gatewaySettings
                            };
                            const temp = JSON.parse(JSON.stringify(crudAPI));
                            let isSame = true;
                            if (this.previouslyDeployedData !== undefined && this.previouslyDeployedData !== null) {
                                const keys = Object.keys(this.previouslyDeployedData);
                                for (const key of keys) {
                                    if (JSON.stringify(this.previouslyDeployedData[key]) === JSON.stringify(temp[key])) {
                                        continue;
                                    } else {
                                        isSame = false;
                                        break;
                                    }
                                }
                            } else {
                                isSame = false;
                            }
                            if (isSame === false) {
                                this.createApiWithApi(true, topic, crudAPI);
                            } else {
                                this.loading = false;
                                this.platform.openSnackBar('There are no changes to redeploy this API.', 'Error', {
                                    duration: 5000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                            }
                        } else {
                            const publishdata = {};
                            var message = 'Change in entity';
                            publishdata['origEntity'] = this.origEntity;
                            publishdata['origVersion'] = this.origVersion;
                            publishdata['entity'] = this.items['entityname'];
                            publishdata['version'] = this.items['version'];
                            publishdata['tableName'] = this.items['tableName'];
                            publishdata['origCollection'] = this.origCollection;

                            if (this.origEntity !== this.items['entityname']) {
                                if (this.origVersion !== this.items['version']) {
                                    message = 'Both the name and version of the entity have been changed. Hence this will create another entity : ' + this.items['entityname'] + ' with the version: ' + this.items['version'] + '. Do you want to continue creating a new Data Access Service ?';
                                } else {
                                    message = 'Name of the entity has been changed. Hence this will create another entity : ' + this.items['entityname'] + ' with the version: ' + this.items['version'] + '. Do you want to continue creating a new Data Access Service ?';
                                }
                            } else {
                                if (this.origVersion !== this.items['version']) {
                                    message = 'Version of the entity has been changed. Hence this will create another entity : ' + this.items['entityname'] + ' with the version: ' + this.items['version'] + '. Do you want to continue creating a new Data Access Service ?';
                                }
                            }
                            let entityLength = 0;
                            let versionLength = 0;
                            for (let i = 0; i < this.items['entityname'].length; i++) {
                                if (this.items['entityname'].charCodeAt(i) === 8 || this.items['entityname'].charCodeAt(i) === 32 || (this.items['entityname'].charCodeAt(i) > 64 && this.items['entityname'].charCodeAt(i) < 91) || (this.items['entityname'].charCodeAt(i) > 96 && this.items['entityname'].charCodeAt(i) < 123) || (this.items['entityname'].charCodeAt(i) >= 48 && this.items['entityname'].charCodeAt(i) <= 57)) {
                                    entityLength++;
                                }
                            }

                            for (let i = 0; i < this.items['version'].length; i++) {
                                if (this.items['version'].charCodeAt(i) === 8 || this.items['version'].charCodeAt(i) === 32 || (this.items['version'].charCodeAt(i) > 64 && this.items['version'].charCodeAt(i) < 91) || (this.items['version'].charCodeAt(i) > 96 && this.items['version'].charCodeAt(i) < 123) || (this.items['version'].charCodeAt(i) >= 48 && this.items['version'].charCodeAt(i) <= 57)) {
                                    versionLength++;
                                }
                            }
                            if (versionLength === this.items['version'].length && entityLength === this.items['entityname'].length) {
                                publishdata['message'] = message;
                                if (this.isAPIAlreadyPresentCheckCompleted === false) {
                                    await this.checkForExistingEntityAndExecutor();
                                }

                                if (this.isAPIAlreadyPresent === false) {
                                    const dialogRef = this.dialog.open(EntityVersionChangeConfirmationComponent, {
                                        width: '60%',
                                        data: publishdata
                                    });

                                    dialogRef.afterClosed().subscribe(result => {
                                        if (result) {
                                            // Create API
                                            this.createApiWithApi(false, topic, null);
                                            if (dialogRef.componentInstance.copyData) {
                                                // Handle this
                                            } else {
                                                // Handle this
                                            }
                                        } else {
                                            this.loading = false;
                                        }
                                    });
                                } else {
                                    this.loading = false;
                                    this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                                        duration: 5000,
                                        verticalPosition: 'top',
                                        horizontalPosition: 'center'
                                    });
                                }
                            } else {
                                this.loading = false;
                                // this.platform.openSnackBar('Special characters are not allowed in version and name.', 'Error', {
                                //   duration: 10000,
                                //   verticalPosition: 'top',
                                //   horizontalPosition: 'center'
                                // });
                            }
                        }
                    }
                } else {
                    this.loading = false;
                    this.platform.openSnackBar('Please select at least one API Gateway.', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            } else {
                this.loading = false;
                this.platform.openSnackBar('Please select at least one method.', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        } else {
            this.loading = false;
            this.platform.openSnackBar('Please enter all the required fields.', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    async createOrUpdateApi() {
        this.currentMessage = '';
        const timeStamp = Date.now();
        this.logTimeStamp = timeStamp;
        this.entityName = this.items['entityname'];
        this.version = this.items['version'];

        this.loading = true;
        this.logVisible = false;

        if (this.websocketService.isOpen()) {
            this.connection = true;
            // this.logVisible = true;
        } else {
            this.connection = false;
        }
        this.action = 'redeploy';
        this.entityName = this.entityName;
        this.version = this.version;
        this.listenAPICreation(this.entityName, this.version, timeStamp);

        const methods = [];
        this.methodType.forEach(method => {
            methods.push(method.id);
        });

        // this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REQUIREMENTS, {
        //   info: 'Checking for special characters in Executor name',
        //   type: 'initial',
        //   icon: 'fa fa-newspaper-o'
        // }, timeStamp, this.action);
        // Promise.resolve(this.platform.specialCharAndSpaceValidatorOnPaste(this.items['entityname'])).then(async resp1 => {
        //   if (resp1 === true) {
        //     this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REQUIREMENTS, {
        //       info: 'Checking for special characters in Executor name',
        //       type: 'success',
        //       icon: 'fa fa-newspaper-o'
        //     }, timeStamp, this.action);
        //     this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REQUIREMENTS, {
        //       info: 'Checking for special characters in Executor version',
        //       type: 'initial',
        //       icon: 'fa fa-newspaper-o'
        //     }, timeStamp, this.action);
        //     Promise.resolve(this.platform.specialCharAndSpaceValidatorOnPaste(this.items['version'])).then(async resp2 => {
        //       this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REQUIREMENTS, {
        //         info: 'Checking for special characters in Executor version',
        //         type: 'success',
        //         icon: 'fa fa-newspaper-o'
        //       }, timeStamp, this.action);
        //       if (resp2 === true) {
        if (this.items.entityname !== undefined && this.items.entityname !== null && this.items.entityname.length !== 0 &&
            this.items['version'] !== undefined && this.items['version'] !== null && this.items['version'].length !== 0 &&
            this.items['category'] !== undefined && this.items['category'] !== null && this.items['category'].length !== 0 &&
            this.items['database'] !== undefined && this.items['database'] !== null && this.items['database'].length !== 0) {
            if (methods !== undefined && methods !== null && methods.length !== 0) {
                const temparray = [];
                for (let i = 0; i < this.apiByDefinition['attributes'].length; i++) {
                    if (this.apiByDefinition['attributes'][i]['attributeName'] !== null && this.apiByDefinition['attributes'][i]['type'] !== null) {
                        temparray.push(this.apiByDefinition['attributes'][i]);
                    }
                }
                this.apiByDefinition['attributes'] = temparray;
                if (this.apiByDefinition['attributes'].length === 0) {
                    this.platform.openSnackBar('Please define schema under Schema Definition', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                } else {
                    if (this.origEntity === this.items['entityname'] && this.origVersion === this.items['version']) {

                        const crudAPI = {
                            'entityname': this.items['entityname'],
                            'category': this.items['category'],
                            'version': this.items['version'],
                            'displayname': this.items['displayname'],
                            'description': this.items['description'],
                            'published': this.items['published'],
                            'scopeOfAccess': this.items['scopeOfAccess'],
                            'creationTime': this.items['creationTime'],
                            'lastModifiedTime': Date.now(),
                            'registeredAsIs': false,
                            'database': this.items['database'],
                            'methods': methods,
                            'tableName': this.items['tableName'] !== null ? this.items['tableName'] : this.account_id + '_' + this.items['entityname'] + '_' + this.items['version'],
                            'attributes': this.apiByDefinition.attributes,
                            'apiResponses': this.apiByDefinition['apiResponses'],
                            'referentialKeyConstraints': this.apiByDefinition['referentialKeyConstraints'],
                            'gatewayManagers': this.apiByDefinition['gatewayManagers']
                        };
                        const temp = JSON.parse(JSON.stringify(crudAPI));
                        let isSame = true;
                        if (this.previouslyDeployedData !== undefined && this.previouslyDeployedData !== null) {
                            const keys = Object.keys(this.previouslyDeployedData);
                            for (const key of keys) {
                                if (JSON.stringify(this.previouslyDeployedData[key]) === JSON.stringify(temp[key])) {
                                    continue;
                                } else {
                                    isSame = false;
                                    break;
                                }
                            }
                        } else {
                            isSame = false;
                        }
                        if (isSame === false) {
                            this.updateCheck(crudAPI, this.previouslyDeployedData, timeStamp);
                        } else {
                            this.loading = false;
                            this.platform.openSnackBar('There are no changes to redeploy this API.', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        }
                    } else {
                        const publishdata = {};
                        var message = 'Change in entity';
                        publishdata['origEntity'] = this.origEntity;
                        publishdata['origVersion'] = this.origVersion;
                        publishdata['entity'] = this.items['entityname'];
                        publishdata['version'] = this.items['version'];
                        publishdata['tableName'] = this.items['tableName'];
                        publishdata['origCollection'] = this.origCollection;

                        if (this.origEntity !== this.items['entityname']) {
                            if (this.origVersion !== this.items['version']) {
                                message = 'Both the name and version of the entity have been changed. Hence this will create another entity : ' + this.items['entityname'] + ' with the version: ' + this.items['version'] + '. Do you want to continue creating a new Data Access Service ?';
                            } else {
                                message = 'Name of the entity has been changed. Hence this will create another entity : ' + this.items['entityname'] + ' with the version: ' + this.items['version'] + '. Do you want to continue creating a new Data Access Service ?';
                            }
                        } else {
                            if (this.origVersion !== this.items['version']) {
                                message = 'Version of the entity has been changed. Hence this will create another entity : ' + this.items['entityname'] + ' with the version: ' + this.items['version'] + '. Do you want to continue creating a new Data Access Service ?';
                            }
                        }
                        let entityLength = 0;
                        let versionLength = 0;
                        for (let i = 0; i < this.items['entityname'].length; i++) {
                            if (this.items['entityname'].charCodeAt(i) === 8 || this.items['entityname'].charCodeAt(i) === 32 || (this.items['entityname'].charCodeAt(i) > 64 && this.items['entityname'].charCodeAt(i) < 91) || (this.items['entityname'].charCodeAt(i) > 96 && this.items['entityname'].charCodeAt(i) < 123) || (this.items['entityname'].charCodeAt(i) >= 48 && this.items['entityname'].charCodeAt(i) <= 57)) {
                                entityLength++;
                            }
                        }

                        for (let i = 0; i < this.items['version'].length; i++) {
                            if (this.items['version'].charCodeAt(i) === 8 || this.items['version'].charCodeAt(i) === 32 || (this.items['version'].charCodeAt(i) > 64 && this.items['version'].charCodeAt(i) < 91) || (this.items['version'].charCodeAt(i) > 96 && this.items['version'].charCodeAt(i) < 123) || (this.items['version'].charCodeAt(i) >= 48 && this.items['version'].charCodeAt(i) <= 57)) {
                                versionLength++;
                            }
                        }
                        if (versionLength === this.items['version'].length && entityLength === this.items['entityname'].length) {
                            publishdata['message'] = message;
                            if (this.isAPIAlreadyPresentCheckCompleted === false) {
                                await this.checkForExistingEntityAndExecutor();
                            }

                            if (this.isAPIAlreadyPresent === false) {
                                const dialogRef = this.dialog.open(EntityVersionChangeConfirmationComponent, {
                                    width: '60%',
                                    data: publishdata
                                });

                                dialogRef.afterClosed().subscribe(result => {
                                    if (result) {
                                        // Create API
                                        this.createApi(timeStamp);
                                        if (dialogRef.componentInstance.copyData) {
                                            // Handle this
                                        } else {
                                            // Handle this
                                        }
                                    } else {
                                        this.loading = false;
                                    }
                                });
                            } else {
                                this.loading = false;
                                this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                                    duration: 5000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                            }
                        } else {
                            this.loading = false;
                            // this.platform.openSnackBar('Special characters are not allowed in version and name.', 'Error', {
                            //   duration: 10000,
                            //   verticalPosition: 'top',
                            //   horizontalPosition: 'center'
                            // });
                        }
                    }
                }
            } else {
                this.loading = false;
                this.platform.openSnackBar('Please select atleast one method.', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        } else {
            this.loading = false;
            this.platform.openSnackBar('Please enter all the required fields.', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
        //       }
        //       else {
        //         this.loading = false;
        //         await this.platform.delay(500);
        //         this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REQUIREMENTS, {
        //           info: 'Checking for special characters in Executor version',
        //           type: 'initial',
        //           description: 'Executor version should not have any special characters or spaces in between',
        //           icon: 'fa fa-newspaper-o'
        //         }, timeStamp, this.action);
        //         // this.platform.openSnackBar('Executor version should not have any special characters or spaces in between', 'Error', {
        //         //   duration: 10000,
        //         //   verticalPosition: 'top',
        //         //   horizontalPosition: 'center'
        //         // });
        //       }
        //     });
        //   } else {
        //     this.loading = false;
        //     await this.platform.delay(500);
        //     this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REQUIREMENTS, {
        //       info: 'Checking for special characters in Executor name',
        //       type: 'fatal',
        //       description: 'Executor name should not have any special characters or spaces in between',
        //       icon: 'fa fa-newspaper-o'
        //     }, timeStamp, this.action);
        //     // this.platform.openSnackBar('Executor name should not have any special characters or spaces in between', 'Error', {
        //     //   duration: 10000,
        //     //   verticalPosition: 'top',
        //     //   horizontalPosition: 'center'
        //     // });
        //   }
        // });

    }

    updatePreviouslydeployedData(updatedAPI) {
        this.previouslyDeployedData = {
            'entityname': updatedAPI['entityname'],
            'category': updatedAPI['category'],
            'version': updatedAPI['version'],
            'displayname': updatedAPI['displayname'],
            'description': updatedAPI['description'],
            'scopeOfAccess': updatedAPI['scopeOfAccess'],
            'database': updatedAPI['database'],
            'methods': updatedAPI['methods'],
            'tableName': updatedAPI['tableName'],
            'published': updatedAPI['published'],
            'attributes': updatedAPI.attributes,
            'apiResponses': updatedAPI['apiResponses'],
            'gatewayManagers': updatedAPI['gatewayManagers'],
        };
        if (updatedAPI['referentialKeyConstraints']) {
            this.previouslyDeployedData['referentialKeyConstraints'] = updatedAPI['referentialKeyConstraints'];
        }
    }

    generateExecutorAgain() {
        window.location.reload();
    }

    closeNonWSDialogBox() {
        if (this.showDialogOnNonWebsocketConnection) {
            this.showDialogOnNonWebsocketConnection.close();
        }
        if (!this.connection) {
            this.logVisible = true;
            this.refreshLogCount++;
        }
    }

    displaySnackBarWithWS(type, duration, msg) {
        if (!this.websocketService.isOpen()) {
            this.platform.openSnackBar(msg, type, {
                duration: duration,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    updateCheck(crudAPI, oldAPI, timeStamp) {
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
        });
        this.confPost.getEntityUsagesWithTestsuites(this.partner, this.account_id, this.partnerKey, crudAPI.entityname, crudAPI.version).subscribe(response => {
            this.dependencyApis = response;
            loaderDialog.close();
            const dialogRef = this.dialog.open(DependencyCheckComponent, {
                width: '60%',
                height: 'auto',
                maxHeight: '70vh',
                data: {
                    executors: this.dependencyApis,
                    executor_name: crudAPI.entityname,
                    executor_version: crudAPI.version
                }
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result && result.continue) {
                    this.updateApi(crudAPI, oldAPI, timeStamp, result.mode);
                } else {
                    this.loading = false;
                }
            });

        }, error1 => {
            loaderDialog.close();
            this.platform.openSnackBar('Error while fetching the usages of the API. Please try again later.', 'Error', {
                duration: 10000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    updateApi(crudAPI, oldAPI, timeStamp, testMode = 'notests') {
        const that = this;
        this.save = false;

        let entityLength = 0;
        let versionLength = 0;
        var methods = [];
        this.methodType.forEach(method => {
            methods.push(method.id);
        });

        if (this.websocketService.isOpen()) {
            this.logVisible = true;
        } else {
            this.showDialogOnNonWebsocketConnection = this.dialog.open(LoaderWithProgressComponent, {
                maxWidth: '95vw',
                maxHeight: '60vh',
                data: {
                    message: 'API deployment is under progress. Please don\'t close the window'
                }
            });
        }

        Promise.resolve(this.platform.specialCharAndPasteValidationForEntityNameAndVersion(this.items['entityname'], this.items['version'], timeStamp, this.action)).then(resp1 => {

            if (resp1) {
                for (let i = 0; i < this.items['entityname'].length; i++) {
                    if (this.items['entityname'].charCodeAt(i) === 8 || this.items['entityname'].charCodeAt(i) === 32 || (this.items['entityname'].charCodeAt(i) > 64 && this.items['entityname'].charCodeAt(i) < 91) || (this.items['entityname'].charCodeAt(i) > 96 && this.items['entityname'].charCodeAt(i) < 123) || (this.items['entityname'].charCodeAt(i) >= 48 && this.items['entityname'].charCodeAt(i) <= 57)) {
                        entityLength++;
                    }
                }

                for (let i = 0; i < this.version.length; i++) {
                    if (this.items['version'].charCodeAt(i) === 8 || this.items['version'].charCodeAt(i) === 32 || (this.items['version'].charCodeAt(i) > 64 && this.items['version'].charCodeAt(i) < 91) || (this.items['version'].charCodeAt(i) > 96 && this.items['version'].charCodeAt(i) < 123) || (this.items['version'].charCodeAt(i) >= 48 && this.items['version'].charCodeAt(i) <= 57)) {
                        versionLength++;
                    }
                }
                this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_DESIGN, {
                    info: 'Reading schema from API design',
                    type: 'inital',
                    icon: 'fa fa-clone'
                }, timeStamp, this.action);
                if (entityLength === this.items['entityname'].length) {
                    if (versionLength === this.items['version'].length) {
                        if (methods.length > 0) {
                            this.loading = true;
                            this.platform.delay(1000);
                            this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_DESIGN, {
                                info: 'Reading schema from API design',
                                type: 'success',
                                icon: 'fa fa-clone'
                            }, timeStamp, this.action);
                            this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_DEVELOPMENT, {
                                info: 'Generating code for the schema',
                                type: 'initial',
                                icon: 'fa fa-edit'
                            }, timeStamp, this.action);
                            this.platform.delay(1000);
                            // if (isSame === false) {false
                            this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REDEPLOYMENT, {
                                info: 'Updating API Executor',
                                type: 'initial',
                                icon: 'fa fa-cloud-upload'
                            }, timeStamp, this.action);
                            this.confPost.updateEntity(this.partner, this.accounts, crudAPI).subscribe(async data => {
                                this.platform.updateAPIAuditLog(this.partner, this.account_id, crudAPI['entityname'], crudAPI['version'], 'DAAS', crudAPI, this.items);
                                // this.previouslyDeployedData = JSON.parse(JSON.stringify(crudAPI));
                                // this.updatePreviouslydeployedData(JSON.parse(JSON.stringify(crudAPI)));
                                Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'dataaccessapi_edit_redeploy_success', 'INFO', data.status, data.statusText, '', crudAPI, data, this.router.url)).then(response => {
                                    const payloadToSend = {
                                        actions: response
                                    };
                                    this.dataAccessListenerInstance.dataAccessListener.emit({
                                        type: 'audit',
                                        id: localStorage.getItem('IdOfSession'),
                                        payload: payloadToSend
                                    });
                                });
                                this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_DEVELOPMENT, {
                                    info: 'Generating code for the schema',
                                    type: 'success'
                                }, timeStamp, this.action);

                                this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REDEPLOYMENT, {
                                    info: 'Updating API Executor',
                                    type: 'success',
                                    icon: 'fa fa-cloud-upload'
                                }, timeStamp, this.action);

                                if (this.items['published']) {
                                    this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_GATEWAY_MANAGEMENT, {
                                        info: 'Updating Gateway Settings for the API',
                                        type: 'initial',
                                        icon: 'fa fa-shield'
                                    }, timeStamp, this.action);
                                    await this.kongService.updateRouteWithMethods(this.partner, this.accounts, this.items['entityname'], this.items['version'], methods, timeStamp, this.action);
                                    this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_GATEWAY_MANAGEMENT, {
                                        info: 'Updating Gateway Settings for the API',
                                        type: 'success',
                                        icon: 'fa fa-shield'
                                    }, timeStamp, this.action);
                                    this.save = false;
                                    if (!this.ispublished) {
                                        this.Blocks = [4, 5];
                                        const blockLength = this.Blocks.length;
                                        const blockStart = this.BlockList[this.Blocks[0]];
                                        const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                                        this.progress = blockStart;
                                        this.save = true;
                                        // if (!this.websocketService.isOpen()) {
                                        //     this.closeNonWSDialogBox();
                                        //     that.setInterval(blockEnd, true);
                                        // }
                                        // this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                        this.leftPanelDataListener.changeInLeftPanelDataV2.emit('dataaccess');
                                        this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                    } else {
                                        this.Blocks = [1, 2, 3, 4];
                                        const blockLength = this.Blocks.length;
                                        const blockStart = this.BlockList[this.Blocks[0]];
                                        const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                                        this.progress = blockStart;
                                        this.save = true;
                                        // if (!this.websocketService.isOpen()) {
                                        //     this.closeNonWSDialogBox();
                                        //     // that.setInterval(blockEnd, true);
                                        // }
                                        // this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                        this.leftPanelDataListener.changeInLeftPanelDataV2.emit('dataaccess');
                                        this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                    }
                                } else {
                                    this.Blocks = [1, 2, 3];
                                    this.save = true;
                                    const blockLength = this.Blocks.length;
                                    const blockStart = this.BlockList[this.Blocks[0]];
                                    const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                                    this.progress = blockStart;

                                    // this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                    this.leftPanelDataListener.changeInLeftPanelDataV2.emit('dataaccess');
                                    this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                }

                                this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REDEPLOYMENT, {
                                    info: 'Redeploying API',
                                    type: 'initial',
                                    icon: 'fa fa-cloud-upload'
                                }, timeStamp, this.action);
                                this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REDEPLOYMENT, {
                                    info: 'Redeploying API',
                                    type: 'success',
                                    icon: 'fa fa-cloud-upload'
                                }, timeStamp, this.action);

                                if (testMode === 'alltests') {
                                    this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_TESTING, {
                                        info: 'Executing test-suites for API usages',
                                        icon: 'fa fa-check-square-o',
                                        type: 'initial',
                                        messageType: 'test-results'
                                    }, this.logTimeStamp, this.action);
                                    this.confPost.getEntityTestSuiteResult(this.partner, this.account_id, this.partnerKey, this.entityName, this.version).subscribe(async response => {
                                        let suiteResponse: any;
                                        suiteResponse = response;

                                        if (suiteResponse.testsPassRate === 100) {
                                            this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_TESTING, {
                                                info: 'Executing test-suites for API usages',
                                                icon: 'fa fa-check-square-o',
                                                type: 'success',
                                                messageType: 'test-results',
                                                description: 'Test Suite pass rate: 100%',
                                                data: {testResultId: suiteResponse['resultsId']}
                                            }, this.logTimeStamp, this.action);
                                            this.updatePreviouslydeployedData(JSON.parse(JSON.stringify(crudAPI)));
                                            await this.finishAPIDeployment(this.entityName, this.version, this.action, this.logTimeStamp);
                                        } else {
                                            this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_TESTING, {
                                                info: 'Executing test-suites for API usages',
                                                icon: 'fa fa-check-square-o',
                                                type: 'warning',
                                                description: 'Expected Test Suite Pass rate: 100%. Actual pass rate: ' + suiteResponse['testsPassRate'] + '%',
                                                messageType: 'test-results',
                                                data: {testResultId: suiteResponse['resultsId']}
                                            }, this.logTimeStamp, this.action);
                                            await this.revertExecutorChanges(oldAPI, this.entityName, this.version, this.action, this.logTimeStamp);
                                        }
                                    }, async error1 => {
                                        this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_TESTING, {
                                            info: 'Executing test-suites for API usages',
                                            icon: 'fa fa-check-square-o',
                                            type: 'error',
                                            messageType: 'test-results',
                                            description: 'Testsuite execution failed. Please try again.'
                                        }, this.logTimeStamp, this.action);
                                        await this.revertExecutorChanges(oldAPI, this.entityName, this.version, this.action, this.logTimeStamp);

                                    });

                                } else if (testMode === 'force') {
                                    this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_TESTING, {
                                        info: 'Executing test-suites for API usages',
                                        icon: 'fa fa-check-square-o',
                                        type: 'initial'
                                    }, this.logTimeStamp, this.action);
                                    this.confPost.getEntityTestSuiteResult(this.partner, this.account_id, this.partnerKey, this.entityName, this.version).subscribe(async response => {
                                        let suiteResponse: any;
                                        suiteResponse = response;

                                        this.updatePreviouslydeployedData(JSON.parse(JSON.stringify(crudAPI)));
                                        if (suiteResponse.testsPassRate === 100) {
                                            this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_TESTING, {
                                                info: 'Executing test-suites for API usages',
                                                icon: 'fa fa-check-square-o',
                                                type: 'success',
                                                messageType: 'test-results',
                                                description: 'Test Suite pass rate: 100%',
                                                data: {testResultId: suiteResponse['resultsId']}
                                            }, this.logTimeStamp, this.action);
                                            await this.finishAPIDeployment(this.entityName, this.version, this.action, this.logTimeStamp);
                                        } else {
                                            this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_TESTING, {
                                                info: 'Executing test-suites for API usages',
                                                icon: 'fa fa-check-square-o',
                                                type: 'warning-low',
                                                description: 'Expected Test Suite Pass rate: 100%. Actual pass rate: ' + suiteResponse['testsPassRate'] + '%',
                                                messageType: 'test-results',
                                                data: {testResultId: suiteResponse['resultsId']}
                                            }, this.logTimeStamp, this.action);
                                            await this.finishAPIDeployment(this.entityName, this.version, this.action, this.logTimeStamp);
                                        }

                                    }, async error1 => {
                                        this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_TESTING, {
                                            info: 'Executing test-suites for API usages',
                                            icon: 'fa fa-check-square-o',
                                            type: 'error',
                                            description: 'Testsuite execution failed. Please try again.'
                                        }, this.logTimeStamp, this.action);
                                        this.updatePreviouslydeployedData(JSON.parse(JSON.stringify(crudAPI)));
                                        await this.finishAPIDeployment(this.entityName, this.version, this.action, this.logTimeStamp);
                                    });
                                } else {
                                    this.updatePreviouslydeployedData(JSON.parse(JSON.stringify(crudAPI)));
                                    this.finishAPIDeployment(this.entityName, this.version, this.action, this.logTimeStamp);
                                }

                            }, error => {
                                this.loading = false;
                                this.closeNonWSDialogBox();
                                let errorMessage = '';
                                if (error.error['message']) {
                                    errorMessage = error.error.message;
                                } else {
                                    // const dialogRef = this.dialog.open(DialogComponent, {
                                    //   data: {title: 'Error while Updating', message: error.error}
                                    // });
                                    errorMessage = error.error;
                                }
                                this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REDEPLOYMENT, {
                                    info: 'Updating API Executor',
                                    type: 'fatal',
                                    description: errorMessage,
                                    icon: 'fa fa-cloud-upload'
                                }, timeStamp, this.action);
                                Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'dataaccessapi_edit_redeploy_failed', 'ERROR', error.status, error.statusText, errorMessage, crudAPI, error, this.router.url)).then(response => {
                                    const payloadToSend = {
                                        actions: response
                                    };
                                    this.dataAccessListenerInstance.dataAccessListener.emit({
                                        type: 'audit',
                                        id: localStorage.getItem('IdOfSession'),
                                        payload: payloadToSend
                                    });
                                });
                                // this.platform.openSnackBar('Error while adding Entity', 'Error', {
                                //     duration: 5000,
                                //     verticalPosition: 'top',
                                //     horizontalPosition: 'center'
                                // });
                                // this.displaySnackBarWithWS('Error', 5000, 'Error while adding Entity');
                            });
                            // } else {
                            //     this.loading = false;
                            //     this.platform.openSnackBar('There are no changes to redeploy this API.', 'Error', {
                            //         duration: 5000,
                            //         verticalPosition: 'top',
                            //         horizontalPosition: 'center'
                            //     });
                            // }
                        } else {
                            this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REDEPLOYMENT, {
                                info: 'Validating executor methods',
                                type: 'fatal',
                                description: 'Please select atleast one method.',
                                icon: 'fa fa-newspaper-o'
                            }, timeStamp, this.action);
                            this.loading = false;
                            this.closeNonWSDialogBox();
                            // this.displaySnackBarWithWS('Error', 5000, 'Please select atleast one method.');
                            // this.platform.openSnackBar('Please select atleast one method.', 'Error', {
                            //     duration: 5000,
                            //     verticalPosition: 'top',
                            //     horizontalPosition: 'center'
                            // });

                        }
                    } else {
                        this.loading = false;
                        this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REDEPLOYMENT, {
                            info: 'Checking for special characters in Executor version',
                            type: 'fatal',
                            description: 'Executor version should not have any special characters or spaces in between',
                            icon: 'fa fa-newspaper-o'
                        }, timeStamp, this.action);
                        this.closeNonWSDialogBox();
                        // this.displaySnackBarWithWS('Error', 5000, 'Special characters are not allowed in Version');
                        // this.platform.openSnackBar('Special characters are not allowed in Version', 'Error', {
                        //     duration: 5000,
                        //     verticalPosition: 'top',
                        //     horizontalPosition: 'center'
                        // });

                    }
                } else {
                    this.loading = false;
                    this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REDEPLOYMENT, {
                        info: 'Checking for special characters in Executor name',
                        type: 'fatal',
                        description: 'Executor name should not have any special characters or spaces in between',
                        icon: 'fa fa-newspaper-o'
                    }, timeStamp, this.action);
                    this.closeNonWSDialogBox();
                    // this.displaySnackBarWithWS('Error', 5000, 'Special characters are not allowed in API Name');
                    // this.platform.openSnackBar('Special characters are not allowed in API Name', 'Error', {
                    //     duration: 5000,
                    //     verticalPosition: 'top',
                    //     horizontalPosition: 'center'
                    // });

                }
            } else {
                this.loading = false;
                this.closeNonWSDialogBox();
                // this.displaySnackBarWithWS('Error', 5000, 'Enter a valid API name and version.');
            }

        });
    }


    async finishAPIDeployment(executor_name, executor_version, action, timeStamp, result = {completed: true, document: true}) {
        await this.platform.delay(500);
        if (result.completed) {
            if (result.document) {
                this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_DOCUMENTATION, {
                    info: 'Generating Documentation',
                    type: 'initial',
                    icon: 'fa fa-book'
                }, timeStamp, action);
                await this.platform.delay(1000);
                this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_DOCUMENTATION, {
                    info: 'Generating Documentation',
                    type: 'success',
                    icon: 'fa fa-book'
                }, timeStamp, action);
            }
            await this.platform.delay(1000);
            this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.DONE, {
                info: '',
                type: 'success',
                icon: 'fa fa-check'
            }, timeStamp, action);
        }
        if (!this.websocketService.isOpen()) {
            this.closeNonWSDialogBox();
        }
        this.loading = false;
        this.closeNonWSDialogBox();

    }

    async revertExecutorChanges(oldAPI, entity, version, action, timeStamp) {
        this.platform.publishEventMessage(entity, version, environment.pubsubtitles.API_TESTING, {
            info: 'Reverting changes to API',
            icon: 'fa fa-check-square-o',
            type: 'initial'
        }, timeStamp, action);
        this.confPost.updateEntity(this.partner, this.accounts, oldAPI).subscribe(async data => {

            const methods = [];
            const methodType = [];
            oldAPI.methods.forEach(method => {
                methodType.push({'id': method, 'itemName': method});
            });
            methodType.forEach(method => {
                methods.push(method.id);
            });

            await this.kongService.updateRouteWithMethods(this.partner, this.accounts, oldAPI['entityname'], oldAPI['version'], methods, timeStamp, action);
            this.platform.publishEventMessage(entity, version, environment.pubsubtitles.API_TESTING, {
                info: 'Reverting changes to API',
                icon: 'fa fa-check-square-o',
                type: 'success'
            }, timeStamp, action);
            await this.finishAPIDeployment(entity, version, action, timeStamp, {completed: false, document: false});
        }, error1 => {
            this.platform.publishEventMessage(entity, version, environment.pubsubtitles.API_TESTING, {
                info: 'Reverting changes to API',
                icon: 'fa fa-check-square-o',
                type: 'fatal'
            }, timeStamp, action);
            this.finishAPIDeployment(entity, version, action, timeStamp, {completed: false, document: false});
        });
    }

    manageProgress(endBlock, showPanel) {
        // if (this.progress >= endBlock) {
        //     this.showNextPanel = showPanel;
        // this.confPost.getPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
        //     let item = data;
        // this.kongService.getKeyAuthForConsumerInApiGatewayByNameOrId(item['primary_email']).subscribe(keys => {
        let apiKey = localStorage.getItem('apikey');
        const dialogRef = this.dialog.open(DialogComponent, {
            maxWidth: '95vw',
            data: {
                type: 'dataaccess',
                save: true,
                ispublished: this.ispublished,
                gatewayFullUrl: this.gatewayUrl,
                Blocks: this.Blocks,
                version: this.version,
                showNextPanel: false,
                partner: this.partner,
                account: this.account_id,
                entityName: this.entityName,
                apiKey: apiKey,
                partnerKey: this.partnerKey
            }
        });
        dialogRef.afterClosed().subscribe(async result => {
            if (result === 'create') {
                await this.router.navigateByUrl('/dataaccessapi');
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else if (result === 'edit') {
                const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                    maxWidth: '95vw',
                    maxHeight: '60vh',
                });
                await this.getEntity(this.partner, this.account_id, this.entityName, this.version).then(resp => {
                    loaderDialog.close();
                    this.router.navigateByUrl('/entity/edit?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.entityName + '&version=' + this.version);
                });
            } else if (result === 'data') {
                this.router.navigateByUrl('/api?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.entityName + '&version=' + this.version);
            } else if (result === 'devex') {
                this.router.navigateByUrl('/devex?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.entityName + '&version=' + this.version);
            }
        });
        // });
        // });
        this.loading = false;
        this.ngOnDestroy();
        // } else {
        //     this.progress = this.progress + incr;
        // }
        // if (this.progress <= 35) {
        //     this.progressMessage = 'Setting Up API';
        // } else if (this.progress > 35 && this.progress <= 70) {
        //     this.progressMessage = 'Setting Up Database';
        //     /*} else if (this.progress > 70 && this.progress <= 98) {
        //         this.progressMessage = 'Creating dedicated File storage for your account';*/
        // } else if (this.progress > 70) {
        //     this.progressMessage = 'Deploying into Cloud';
        // }
    }

    navigateToData() {
        this.router.navigate(['/api'],
            {
                queryParams: {
                    partner: localStorage.getItem('partner'),
                    account: localStorage.getItem('account'),
                    entity: $('#entityName').val(),
                    version: this.items['version']
                }
            });
    }

    getSubAttributes(that) {
        let subAttribute = [];
        const func = this;
        if ($(that).next('.sub-array').length) {
            $(that).next('.sub-array').children('.add-array').children('table').children('tbody').children('.root').each(function () {
                subAttribute.push({
                    'attributeName': $(this).find('td:first').find('input').val(),
                    'displayName': null,
                    'description': null,
                    'type': $(this).find('td:eq(1)').find('select').val(),
                    'attributeType': $(this).find('td:eq(2)').find('select').val(),
                    'required': $(this).find('td:eq(3)').find('input').prop('checked'),
                    'dataStoragePolicy': $(this).find('td:eq(4)').find('select').val(),
                    'apiAccessPolicy': $(this).find('td:eq(5)').find('select').val(),
                    'displayPolicy': null,
                    'subType': func.getSubAttributes($(this))
                });
            });
        } else {
            subAttribute = null;
        }
        return subAttribute;
    }

    cloneApi() {
        this.buttonClick = true;
        const that = this;
        const attribute = [];
        $('#attributeTable').children('tbody').children('.root').each(function () {
            if ($(this).find('input:first').val().trim() == '') {
                $(this).find('input:first').focus();
                return false;
            }
            attribute.push({
                'attributeName': $(this).find('td:first').find('input').val(),
                'displayName': null,
                'description': null,
                'type': $(this).find('td:eq(1)').find('select').val(),
                'attributeType': $(this).find('td:eq(2)').find('select').val(),
                'required': $(this).find('td:eq(3)').find('input').prop('checked'),
                'dataStoragePolicy': $(this).find('td:eq(4)').find('select').val(),
                'apiAccessPolicy': $(this).find('td:eq(5)').find('select').val(),
                'displayPolicy': null,
                'subType': that.getSubAttributes($(this))
            });
        });
        const crudAPI = {
            'entityname': $('#entityName').val(),
            'category': this.items['category'],
            'version': this.items['version'],
            'displayname': $('#displayName').val(),
            'description': $('#Entitydescription').val(),
            'published': this.items['published'],
            'scopeOfAccess': this.items['scopeOfAccess'],
            'creationTime': this.items['creationTime'],
            'lastModifiedTime': Date.now(),
            'registeredAsIs': false,
            'database': this.items['database'],
            'tableName': this.items['tableName'] !== null ? this.items['tableName'] : this.account_id + '_' + $('#entityName').val() + '_' + this.items['version'],
            'attributes': attribute
        };
        const createDeleteAudit = [{
            'planName': localStorage.getItem('currentPlan'),
            'createdDate': Date.now(),
            'removedDate': null
        }];
        const auditAPI = {
            'partner': localStorage.getItem('partner'),
            'account_id': localStorage.getItem('account'),
            'entityname': $('#entityName').val(),
            'version': ((typeof this.version) == 'object' ? this.version['name'] : this.version),
            'status': 'active',
            'published': this.items['ispublished'],
            'scopeOfAccess': this.items['scopeSelected'],
            'creationTime': this.items['creationTime'],
            'lastModifiedTime': Date.now(),
            'registeredAsIs': false,
            'currentPlanName': localStorage.getItem('currentPlan'),
            'createDeleteAudit': createDeleteAudit
        };
        this.confPost.insertEntity(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI).subscribe(data => {
            this.platform.openSnackBar('The API has successfully been cloned successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            this.cloneSave = true;
            this.showNextPanel = true;

        }, error => {
            this.platform.openSnackBar('Error while cloning the API', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
        this._service.addAuditItem(auditAPI, 'v1', 'billing', 'billing', 'PartnerApiAudit').subscribe(
            status => {
            }, error => {
                this.platform.openSnackBar('Error while adding audit details for the Entity Creation', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        this.APILoading = true;
    }

    private _filter(name: string): ICategory[] {
        const filterValue = name.toLowerCase();

        return this.options.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
    }

    CloneAPIwithOptions() {
        this.buttonClick = true;
        if (this.cloneOptionSelected === 'clone') {
            this.cloneApi();
        } else {
            this.CloneWithData();
        }
        this.cloneSave = true;
    }

    CloneWithData() {
        this.buttonClick = true;
        const APIUrl = environment.apihost + '/' + this.version + '/config/' + this.partner + '/' + this.accounts + '/' + this.entity;
        const dataroot = '';
        const Header = [];
        Header.push({
            'Content-Type': 'application/json'
        });
        Header.push({
            'pkey': '3fe18f9884ea832e3fede1e661740c4a'
        });
        const crudAPI = {
            'entityname': $('#entityName').val(),
            'category': this.items['category'],
            'version': this.items['version'],
            'displayname': $('#displayName').val(),
            'description': $('#Entitydescription').val(),
            'published': this.items['published'],
            'scopeOfAccess': this.items['scopeOfAccess'],
            'creationTime': this.items['creationTime'],
            'lastModifiedTime': Date.now(),
            'registeredAsIs': false,
            'database': this.items['database'],
            'importData': true,
            'APIUrl': APIUrl,
            'dataroot': dataroot,
            'Header': Header
        };
        this.confPost.createAPI(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI).subscribe(data => {
            this.platform.openSnackBar('API Created successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            this.APILoading = true;


        }, error => {
            this.platform.openSnackBar(error.error.message, 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    navigateDataView() {
        this.router.navigate(['/api'],
            {
                queryParams: {
                    partner: localStorage.getItem('partner'),
                    account: localStorage.getItem('partner'),
                    entity: $('#entityName').val(),
                    version: this.items['version']
                }
            });
    }

    navigateAPIReview() {
        this.router.navigate(['/entity/edit'],
            {
                queryParams: {
                    partner: localStorage.getItem('partner'),
                    account: localStorage.getItem('partner'),
                    entity: $('#entityName').val(),
                    version: this.items['version']
                }
            });
    }

    openAttributeDescriptionDialog(definition) {
        const data = {
            'displayName': definition.displayName,
            'description': definition.description,
            'dataStoragePolicy': definition.dataStoragePolicy,
            'apiAccessPolicy': definition.apiAccessPolicy,
            'displayPolicy': definition.displayPolicy,
            'definitionType': definition.type,
            'datatypeFilter': this.dataTypeFilter,
            'compliances': definition.compliances ? definition.compliances : []
        };
        const dialogRef = this.dialog.open(AttributeDescriptionComponent, {
            data: data
        });

        dialogRef.afterClosed().subscribe(result => {
            this.accept = result;
            definition.displayName = data.displayName;
            definition.description = data.description;
            definition.dataStoragePolicy = data.dataStoragePolicy;
            definition.apiAccessPolicy = data.apiAccessPolicy;
            definition.displayPolicy = data.displayPolicy;
            definition.compliances = data.compliances;
        });
    }

    setPublish(value: boolean) {
        this.items['published'] = value;
    }

    setInterval(blockEnd, nextPanel) {
        this.destroy = setInterval(() => this.manageProgress(blockEnd, nextPanel), 1000);
    }

    ngOnDestroy() {
        clearInterval(this.destroy);
    }

    runTests() {
        this.testLoading = true;
        this.confPost.testEntityTestsuiteWithUsages(this.partner, this.account_id, this.partnerKey, {
            entity: this.origEntity,
            version: this.origVersion
        }).subscribe(res => {
            this.testLoading = false;
            if (res) {
                this.testSuiteResponse = res;

                if (this.testSuiteResponse['testCaseResults'] !== undefined) {
                    const dialogRef = this.dialog.open(TestReportComponent, {
                        height: '80%',
                        width: '80%',
                        data: {
                            testSuitePayload: {name: this.testSuiteResponse.name},
                            testSuiteResponse: this.testSuiteResponse
                        }
                    });
                } else {
                    this.platform.openSnackBar('Error while testing the API. Please try again after sometime.', 'Error', {
                        duration: 7000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            }

        }, error1 => {
            this.testLoading = false;
            this.platform.handleErrorGracefully(error1, 'Error while testing the API. Please try again after sometime.');

        });
    }

    async copyTo() {
        const metaSchema = JSON.parse(JSON.stringify(this.apiByDefinition));
        if (this.selectedDatatypeFilter && this.selectedDatatypeFilter !== null && this.selectedDatatypeFilter !== undefined) {
            metaSchema['databaseType'] = this.selectedDatatypeFilter;
            metaSchema['is_nosql'] = this.isSelectedDatabaseNatureNoSQL;
        } else {
            await this.filterDataTypes(this.apiByDefinition.database);
            metaSchema['databaseType'] = this.selectedDatatypeFilter;
            metaSchema['is_nosql'] = this.isSelectedDatabaseNatureNoSQL;
        }
        this.platform.copyToPartner(this.apiByDefinition['entityname'], this.apiByDefinition['version'], 'DAAS', metaSchema);
    }

    copyText(val) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = $(val).text();
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        alert('CURL command copied to clipboard');
    }

    saveAPI() {

        const methods = [];
        this.methodType.forEach(method => {
            methods.push(method.id);
        });

        const savePayload = {
            partner: '',
            account: '',
            executor_name: '',
            executor_type: '',
            by: '',
            executor_version: '',
            action: ''
        };

        savePayload.partner = this.partner;
        savePayload.account = this.account_id;
        savePayload['at'] = Date.now();
        savePayload.by = this.partner;

        if (this.items['entityname'] !== null && this.items['entityname'] !== undefined && this.items['entityname'] !== '') {
            savePayload.executor_name = this.items['entityname'];
        } else {
            savePayload.executor_name = Date.now().toString();
        }

        savePayload.executor_version = ((typeof this.version) === 'object' ? this.version['name'] : this.version);
        savePayload.action = 'UPDATE';
        savePayload.executor_type = 'API';

        const crudAPI = {
            'entityname': this.items['entityname'],
            'category': this.items['category'],
            'version': this.items['version'],
            'displayname': this.items['displayname'],
            'description': this.items['description'],
            'published': this.items['published'],
            'scopeOfAccess': this.items['scopeOfAccess'],
            'creationTime': this.items['creationTime'],
            'lastModifiedTime': Date.now(),
            'registeredAsIs': false,
            'database': this.items['database'],
            'methods': methods,
            'tableName': this.items['tableName'] !== null ? this.items['tableName'] : this.account_id + '_' + this.items['entityname'] + '_' + this.items['version'],
            'attributes': this.apiByDefinition.attributes,
            'apiResponses': this.apiByDefinition['apiResponses'],
            'referentialKeyConstraints': this.apiByDefinition['referentialKeyConstraints'],
            'gatewayManagers': this.apiByDefinition['gatewayManagers']
        };

        savePayload['executor'] = crudAPI;
        const temp = JSON.parse(JSON.stringify(savePayload['executor']));
        let isSame = true;
        if (this.previousSavedData !== undefined && this.previousSavedData !== null) {
            if (Object.keys(this.previousSavedData).length === Object.keys(temp).length) {
                const keyArray = Object.keys(this.previousSavedData);
                for (const key of keyArray) {
                    if (JSON.stringify(this.previousSavedData[key]) === JSON.stringify(temp[key])) {
                        continue;
                    } else {
                        isSame = false;
                        break;
                    }
                }
            } else {
                isSame = false;
            }
        } else {
            isSame = false;
        }
        if (isSame === false) {
            this.confPost.saveExecutorInformation('v1', savePayload).subscribe(data => {
                this.previousSavedData = JSON.parse(JSON.stringify(savePayload['executor']));
                this.platform.openSnackBar('API has been saved successfully.', 'Success', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.leftPanelDataListener.saveEntityAndExecutors.emit('success');
            }, error => {
                this.platform.openSnackBar('Error while saving the API. Please try again after sometime.', 'Error', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        } else {
            this.platform.openSnackBar('No changes to save for this Data Access API.', 'Error', {
                duration: 10000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    emitAPI() {
        const methods = [];
        this.methodType.forEach(method => {
            methods.push(method.id);
        });
        const entity = {
            'entityname': this.items['entityname'],
            'category': this.items['category'],
            'version': this.items['version'],
            'lastModifiedTime': Date.now(),
            'database': this.items['database'],
            'methods': methods,
            'tableName': this.items['tableName'] !== null ? this.items['tableName'] : this.account_id + '_' + this.items['entityname'] + '_' + this.items['version'],
            'attributes': this.apiByDefinition.attributes,
            'gatewayName': this.selectedAPIGatewayName,
            'scope': this.scopeSelected,
            'isPublished': this.ispublished,
            'gatewayManagers': this.apiByDefinition['gatewayManagers']
        };
        this.onSavingEntity.emit(entity);
    }

    checkForExistingEntityAndExecutorFromFocusOut() {
        setTimeout(() => {
            this.checkForExistingEntityAndExecutor();
        }, 1000);
    }

    CheckForExistingEntityOrExecutor() {
        return new Promise((resolve, reject) => {
            Promise.resolve(this.platform.CheckForExistingEntityOrExecutor(this.items['entityname'], this.items['version'])).then(response => {
                this.isAPIAlreadyPresent = false;
                this.isAPIAlreadyPresentCheckCompleted = false;
                this.previouslyCheckedName = this.entityName;
                this.previouslyCheckedVersion = this.version;
                resolve('success');
            }, error => {
                if (error && error.status) {
                    if (error.status === 'already exists') {
                        this.isAPIAlreadyPresent = true;
                        this.isAPIAlreadyPresentCheckCompleted = false;
                        this.previouslyCheckedName = this.items['entityname'];
                        this.previouslyCheckedVersion = this.items['version'];
                        resolve('failed');
                        this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    } else if (error.status === 'failed') {
                        this.isAPIAlreadyPresent = true;
                        this.isAPIAlreadyPresentCheckCompleted = false;
                        this.previouslyCheckedName = this.items['entityname'];
                        this.previouslyCheckedVersion = this.items['version'];
                        resolve('failed');
                        this.platform.openSnackBar('Error occurred while checking your existing API information. Please try again after sometime.', 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }
                }
            });
        });
    }

    checkForExistingEntityAndExecutor() {
        return new Promise(async (resolve, reject) => {
            if (this.items['entityname'] !== null && this.items['entityname'] !== undefined && this.items['entityname'] !== '' && this.items['version'] !== null && this.items['version'] !== undefined && this.items['version'] !== '') {
                if (this.isAPIAlreadyPresentCheckCompleted === false) {
                    if (this.previouslyCheckedName !== undefined && this.previouslyCheckedName !== null && this.previouslyCheckedVersion !== undefined && this.previouslyCheckedVersion !== null) {
                        if (this.items['entityname'] !== this.origEntity || this.items['version'] !== this.origVersion) {
                            if (this.previouslyCheckedName !== this.items['entityname'] || this.previouslyCheckedVersion !== this.items['version']) {
                                this.isAPIAlreadyPresentCheckCompleted = true;
                                await this.CheckForExistingEntityOrExecutor();
                                resolve('success');
                            } else {
                                resolve('success');
                            }
                        } else {
                            resolve('success');
                        }
                    } else {
                        if (this.items['entityname'] !== this.origEntity || this.items['version'] !== this.origVersion) {
                            this.isAPIAlreadyPresentCheckCompleted = true;
                            await this.CheckForExistingEntityOrExecutor();
                            resolve('success');
                        } else {
                            resolve('success');
                        }
                    }
                } else {
                    resolve('success');
                }
            }
        });
    }

    createApiWithApi(isUpdate, topic, crudAPI) {
        this.loading = true;
        const methods = [];
        this.methodType.forEach(method => {
            methods.push(method.id);
        });

        if (this.websocketService.isOpen()) {
            this.connection = true;
        } else {
            this.connection = false;
        }
        if (this.websocketService.isOpen()) {
            this.logVisible = true;
        }

        if (this.connection === false) {
            this.showDialogOnNonWebsocketConnection = this.dialog.open(LoaderWithProgressComponent, {
                maxWidth: '95vw',
                maxHeight: '60vh',
                data: {
                    message: 'API deployment is under progress. Please don\'t close the window'
                }
            });
        }

        const gateways = this.gatewayControl.value as string[];
        const gatewaySettings = [];
        if (gateways && gateways.length > 0) {
            for (const gateway of gateways) {
                if (gateway) {
                    gatewaySettings.push({name: gateway});
                }
            }
        }

        if (crudAPI === null) {
            crudAPI = {
                'entityname': this.items['entityname'],
                'category': this.items['category'],
                'version': this.items['version'],
                'displayname': this.items['displayname'],
                'description': this.items['description'],
                'published': this.items['published'],
                'scopeOfAccess': this.items['scopeOfAccess'],
                'creationTime': this.items['creationTime'],
                'lastModifiedTime': Date.now(),
                'registeredAsIs': false,
                'database': this.items['database'],
                'methods': methods,
                'tableName': this.items['tableName'] !== null ? this.items['tableName'] : this.account_id + '_' + this.items['entityname'] + '_' + this.items['version'],
                'attributes': this.apiByDefinition.attributes,
                'apiResponses': this.apiByDefinition['apiResponses'],
                'referentialKeyConstraints': this.apiByDefinition['referentialKeyConstraints'],
                'gatewayManagers': this.apiByDefinition['gatewayManagers'],
                'gatewaySettings': gatewaySettings
            };
        }

        const payload = {
            apiModel: crudAPI,
            topic: topic
        };

        this.confPost.upsertAPIWithCore(localStorage.getItem('partner'), localStorage.getItem('account'), localStorage.getItem('partnerKey'), payload, true, isUpdate, true, true).toPromise().then(response1 => {

            this.entityName = this.items['entityname'];
            this.version = this.items['version'];
            this.updatePreviouslydeployedData(JSON.parse(JSON.stringify(crudAPI)));

            this.leftPanelDataListener.changeInLeftPanelData.emit('update');
            this.loading = false;
            if (this.showDialogOnNonWebsocketConnection) {
                this.showDialogOnNonWebsocketConnection.close();
            }
            if (!this.websocketService.isOpen()) {
                this.logVisible = true;
                this.refreshLogCount++;
            }
        }, error => {

            this.loading = false;
            if (this.showDialogOnNonWebsocketConnection) {
                this.showDialogOnNonWebsocketConnection.close();
            }
            if (!this.websocketService.isOpen()) {
                this.logVisible = true;
                this.refreshLogCount++;
            }
        });
    }

    async createApi(timeStamp) {

        this.loading = true;
        this.save = false;
        const that = this;
        let entityLength = 0;
        let versionLength = 0;
        const methods = [];
        this.methodType.forEach(method => {
            methods.push(method.id);
        });

        if (this.websocketService.isOpen()) {
            this.logVisible = true;
        } else {
            this.showDialogOnNonWebsocketConnection = this.dialog.open(LoaderWithProgressComponent, {
                maxWidth: '95vw',
                maxHeight: '60vh',
                data: {
                    message: 'API deployment is under progress. Please don\'t close the window'
                }
            });
        }

        Promise.resolve(this.platform.specialCharAndPasteValidationForEntityNameAndVersion(this.items['entityname'], this.items['version'], timeStamp, this.action)).then(async resp1 => {
            if (resp1) {
                for (let i = 0; i < this.items['entityname'].length; i++) {
                    if (this.items['entityname'].charCodeAt(i) === 8 || this.items['entityname'].charCodeAt(i) === 32 || (this.items['entityname'].charCodeAt(i) > 64 && this.items['entityname'].charCodeAt(i) < 91) || (this.items['entityname'].charCodeAt(i) > 96 && this.items['entityname'].charCodeAt(i) < 123) || (this.items['entityname'].charCodeAt(i) >= 48 && this.items['entityname'].charCodeAt(i) <= 57)) {
                        entityLength++;
                    }
                }

                for (let i = 0; i < this.items['version'].length; i++) {
                    if (this.items['version'].charCodeAt(i) === 8 || this.items['version'].charCodeAt(i) === 32 || (this.items['version'].charCodeAt(i) > 64 && this.items['version'].charCodeAt(i) < 91) || (this.items['version'].charCodeAt(i) > 96 && this.items['version'].charCodeAt(i) < 123) || (this.items['version'].charCodeAt(i) >= 48 && this.items['version'].charCodeAt(i) <= 57)) {
                        versionLength++;
                    }
                }
                this.platform.publishEventMessage(this.entityName, this.version, 'API DESIGN', {
                    info: 'Preparing for API methods',
                    type: 'initial',
                    icon: 'fa fa-newspaper-o'
                }, timeStamp, this.action);
                await this.platform.delay(500);
                this.platform.publishEventMessage(this.entityName, this.version, 'API DESIGN', {
                    info: 'Preparing for API methods',
                    type: 'success',
                    icon: 'fa fa-newspaper-o'
                }, timeStamp, this.action);
                // if ((this.partnerEntities.filter(element => element.entityname === this.items['entityname'])).length === 0) {
                //         if ((this.partnerExecutors.filter(element => element.executor_name === this.items['entityname'])).length === 0) {
                //                 this.isAPIAlreadyPresent = false;
                //         } else {
                //             if ((this.partnerExecutors.filter(element => (element.executor_version === this.items['version'] && element.executor_name === this.items['entityname']))).length === 0) {
                //                 this.isAPIAlreadyPresent = false;
                //             } else {
                //                 this.isAPIAlreadyPresent = true;
                //             }
                //         }
                // } else {
                //     if ((this.partnerEntities.filter(element => (element.version === this.items['version'] && element.entityname === this.items['entityname']))).length === 0) {
                //         this.isAPIAlreadyPresent = false;
                //     } else {
                //         this.isAPIAlreadyPresent = true;
                //     }
                // }

                // if ((this.partnerEntities.filter(element => (element.entityname === this.items['entityname'] && element.version === this.items['version'])).length === 0)) {
                //     if ((this.partnerExecutors.filter(element => (element.executor_name === this.items['entityname'] && element.executor_version === this.items['version'])).length === 0)) {
                //         this.isAPIAlreadyPresent = false;
                //     } else {
                //         this.isAPIAlreadyPresent = true;
                //     }
                // } else {
                //     this.isAPIAlreadyPresent = true;
                // }

                if (this.isAPIAlreadyPresent === false) {
                    if (entityLength === this.items['entityname'].length) {
                        if (versionLength === this.items['version'].length) {
                            if (methods.length > 0) {
                                // if (!this.isSpecialCharacterInAttribute) {
                                this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_DESIGN, {
                                    info: 'Reading schema from API design',
                                    type: 'inital',
                                    icon: 'fa fa-clone'
                                }, timeStamp, this.action);
                                this.loading = true;
                                const crudAPI = {
                                    'entityname': this.items['entityname'],
                                    'category': this.items['category'],
                                    'version': this.items['version'],
                                    'displayname': this.items['displayname'],
                                    'description': this.items['description'],
                                    'published': this.items['published'],
                                    'scopeOfAccess': this.items['scopeOfAccess'],
                                    'creationTime': this.items['creationTime'],
                                    'lastModifiedTime': Date.now(),
                                    'registeredAsIs': false,
                                    'database': this.items['database'],
                                    'methods': methods,
                                    'tableName': this.items['tableName'] !== null ? this.items['tableName'] : this.account_id + '_' + this.items['entityname'] + '_' + this.items['version'],
                                    'attributes': this.apiByDefinition.attributes,
                                    'apiResponses': this.apiByDefinition['apiResponses'],
                                    'referentialKeyConstraints': this.apiByDefinition['referentialKeyConstraints'],
                                    'gatewayManagers': this.apiByDefinition['gatewayManagers']
                                };
                                this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_DESIGN, {
                                    info: 'Reading schema from API design',
                                    type: 'success',
                                    icon: 'fa fa-clone'
                                }, timeStamp, this.action);
                                this.platform.publishEventMessage(this.entityName, this.version, 'API DEVELOPMENT', {
                                    info: 'Setting up API',
                                    type: 'initial',
                                    icon: 'fa fa-edit'
                                }, timeStamp, this.action);

                                this.confPost.insertEntity(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI).subscribe(async data => {
                                    // Added the below two lines to get the latest entity details that's been created newly by either changing the entity name or version.
                                    this.entityName = this.items['entityname'];
                                    this.version = this.items['version'];
                                    this.updatePreviouslydeployedData(JSON.parse(JSON.stringify(crudAPI)));
                                    if (data && data['message'] === 'API already exists.') {
                                        this.save = false;
                                        this.loading = false;
                                        this.closeNonWSDialogBox();
                                        // this.platform.openSnackBar(data['message'], 'Error', {
                                        //   duration: 5000,
                                        //   verticalPosition: 'top',
                                        //   horizontalPosition: 'center'
                                        // });
                                        this.platform.publishEventMessage(this.entityName, this.version, 'API DEVELOPMENT', {
                                            info: 'Setting up API',
                                            type: 'fatal',
                                            description: data['message'],
                                            icon: 'fa fa-edit'
                                        }, timeStamp, this.action);
                                    } else {
                                        this.platform.publishEventMessage(this.entityName, this.version, 'API DEVELOPMENT', {
                                            info: 'Setting up API',
                                            type: 'success',
                                            icon: 'fa fa-edit'
                                        }, timeStamp, this.action);

                                        if (this.ispublished) {
                                            // this.kongService.configureApiGatewayWithIpRestriction(localStorage.getItem('partner'), localStorage.getItem('account'), this.items['entityname'], this.items['version'], false, false);
                                            await this.kongService.configureApiGatewayWithIpRestrictionWithMethods(localStorage.getItem('partner'), localStorage.getItem('account'), this.entityName, this.version, false, false, methods, timeStamp, this.action);

                                            await this.platform.generateAccountRolePermissionGroupAndPermissions(this.partner, this.account_id, localStorage.getItem('signInEmail'), this.entityName, this.version, 'DAAS', true, timeStamp, this.action);

                                            this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_DOCUMENTATION, {
                                                info: 'Generating Documentation',
                                                type: 'initial',
                                                icon: 'fa fa-book'
                                            }, timeStamp, this.action);
                                            await this.platform.delay(1000);
                                            this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_DOCUMENTATION, {
                                                info: 'Generating Documentation',
                                                type: 'success',
                                                icon: 'fa fa-book'
                                            }, timeStamp, this.action);

                                            this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_TESTING, {
                                                info: 'Checking for testcases <br>Testcases found: 0',
                                                icon: 'fa fa-check-square-o',
                                                type: 'initial'
                                            }, timeStamp, this.action);
                                            await this.platform.delay(1000);
                                            this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_TESTING, {
                                                info: 'Checking for testcases <br>Testcases found: 0',
                                                icon: 'fa fa-check-square-o',
                                                type: 'success'
                                            }, timeStamp, this.action);

                                            await this.platform.delay(2000);
                                            this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.DONE, {
                                                info: '',
                                                type: 'success',
                                                icon: 'fa fa-check'
                                            }, timeStamp, this.action);
                                            this.loading = false;
                                            if (!this.websocketService.isOpen()) {
                                                this.closeNonWSDialogBox();
                                                // that.setInterval(blockEnd, false);
                                            }
                                        }
                                        if (this.ispublished) {
                                            this.Blocks = [1, 2, 3, 4, 5];
                                            const blockLength = this.Blocks.length;
                                            const blockStart = this.BlockList[this.Blocks[0]];
                                            const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                                            this.progress = blockStart;
                                            this.save = true;

                                            // this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                            this.leftPanelDataListener.changeInLeftPanelDataV2.emit('dataaccess');
                                            this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                            this.confPost.getApiExecutorsByPartnerAccountType(localStorage.getItem('partner'), localStorage.getItem('account'), 'API').subscribe(data => {
                                                // localStorage.setItem('dataAccessAPI' , JSON.stringify(data));
                                                this.platform.apiExecutors = data;
                                                // localStorage.setItem('isDataAccessAPISet', 'true');
                                                this.platform.isDataAccessAPISet = 'true';
                                                // localStorage.setItem('updatedDataAccessAPI', JSON.stringify({'entityName': crudAPI['entityname'], 'version': crudAPI['version']}));
                                                this.platform.updatedDataAccessAPI = JSON.stringify({
                                                    'entityName': crudAPI['entityname'],
                                                    'version': crudAPI['version']
                                                });
                                            });
                                        } else {
                                            this.Blocks = [1, 2, 3];
                                            this.save = true;
                                            const blockLength = this.Blocks.length;
                                            const blockStart = this.BlockList[this.Blocks[0]];
                                            const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                                            this.progress = blockStart;
                                            // if (!this.websocketService.isOpen()) {
                                            //     this.closeNonWSDialogBox();
                                            //     // that.setInterval(blockEnd, false);
                                            // }
                                            // this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                            this.leftPanelDataListener.changeInLeftPanelDataV2.emit('dataaccess');
                                            this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                        }
                                    }
                                }, error => {
                                    this.save = false;
                                    // this.ispublished = false;
                                    this.loading = false;
                                    this.closeNonWSDialogBox();
                                    let errorMessage = '';
                                    if (error.error['message']) {
                                        errorMessage = error.error.message;
                                    } else {
                                        const dialogRef = this.dialog.open(DialogComponent, {
                                            data: {title: 'Error while updating', message: error.error}
                                        });
                                        errorMessage = error.error;
                                    }
                                    this.platform.publishEventMessage(this.entityName, this.version, 'API DEVELOPMENT', {
                                        info: 'Setting up API',
                                        type: 'fatal',
                                        description: errorMessage,
                                        icon: 'fa fa-edit'
                                    }, timeStamp, this.action);
                                    // this.platform.openSnackBar('Error while adding Entity', 'Error', {
                                    //   duration: 5000,
                                    //   verticalPosition: 'top',
                                    //   horizontalPosition: 'center'
                                    // });

                                });
                                // if (this.ispublished) {
                                //     this.kongService.configureApiGatewayWithIpRestriction(localStorage.getItem('partner'), localStorage.getItem('account'), this.items['entityname'], this.items['version'], false, false);
                                // }
                                // } else {
                                //     this.platform.openSnackBar('Special characters are not allowed in attribute name', 'Error', {
                                //         duration: 5000,
                                //         verticalPosition: 'top',
                                //         horizontalPosition: 'center'
                                //     });
                                // }
                            } else {
                                this.loading = false;
                                this.closeNonWSDialogBox();
                                this.platform.openSnackBar('Please select atleast one method.', 'Error', {
                                    duration: 5000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                            }
                        } else {
                            this.loading = false;
                            this.closeNonWSDialogBox();
                            this.platform.openSnackBar('Special characters are not allowed in Version', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        }
                    } else {
                        this.loading = false;
                        this.closeNonWSDialogBox();
                        this.platform.openSnackBar('Special characters are not allowed in API Name', 'Error', {
                            duration: 5000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }
                } else {
                    this.loading = false;
                    this.closeNonWSDialogBox();
                    this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            } else {
                this.loading = false;
                this.closeNonWSDialogBox();
            }
        });
    }

    getDefaultGatewaySettings(settingsData) {
        if (settingsData !== null && settingsData !== undefined &&
            settingsData['body'] !== null && settingsData['body'] !== undefined &&
            settingsData['body'][0] !== null && settingsData['body'][0] !== undefined &&
            settingsData['body'][0]['environments'] !== null && settingsData['body'][0]['environments'] !== undefined) {
            for (const envs of settingsData['body'][0]['environments']) {
                if (envs && envs !== null && envs !== undefined) {
                    if (envs['name'] === localStorage.getItem('partner')) {
                        if (envs['services']) {
                            const gatewayService = envs['services'].filter(element => element.type === 'apigateway');
                            if (gatewayService[0]['configurations'] && gatewayService[0]['configurations'] !== null && gatewayService[0]['configurations'] !== undefined && gatewayService[0]['configurations'].length > 0) {
                                this.APIGateways = gatewayService[0]['configurations'];
                            }
                            for (const gateway of gatewayService[0]['configurations']) {
                                if (gateway && gateway !== null && gateway !== undefined && gateway['is_default'] === true && gateway['gateway_configurations'] !== {}) {
                                    this.platform.defaultGatewaySettings = gateway['gateway_configurations'];
                                    this.selection = gateway['gateway_configurations'];
                                    this.selectedAPIGateway = gateway;
                                    this.selectedAPIGatewayName = gateway['name'];
                                    this.apigatewayInstance.APIGatewayListener.emit({selectedAPIGateway: this.selectedAPIGateway});
                                }
                            }
                        }
                    }
                }
            }
        }

    }

    setSelectedAPIGateway(event) {
        for (const envs of this.settingsData['body'][0]['environments']) {
            if (envs && envs !== null && envs !== undefined) {
                if (envs['name'] === localStorage.getItem('partner')) {
                    if (envs['services']) {
                        const gatewayService = envs['services'].filter(element => element.type === 'apigateway');
                        for (const gateway of gatewayService[0]['configurations']) {
                            if (gateway && gateway !== null && gateway !== undefined) {
                                if (gateway['name'] === event) {
                                    this.selection = gateway['gateway_configurations'];
                                    this.selectedAPIGateway = gateway;
                                    this.selectedAPIGatewayName = gateway['name'];
                                    this.apigatewayInstance.APIGatewayListener.emit({selectedAPIGateway: this.selectedAPIGateway});
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    emitIpRestriction(event) {
        if (event.value === 'public') {
            this.listenerServiceInstance.emitIPRestriction.emit({type: this.selectedAPIGateway['type'], status: false});
        } else {
            this.listenerServiceInstance.emitIPRestriction.emit({type: this.selectedAPIGateway['type'], status: true});
        }
    }

    openResponseSettingsDialog(item: any, name: any) {
        const temp = this.partnerExecutors.filter((exec) => exec.executor_category === name.entityname);
        const executor = temp.filter((exec) => exec.executor_method_type === item.method);

        let executor2 = {};

        this.confPost.getApiExecutorByPartnerAccountEntityVersion(this.partner,  this.partner, executor[0]['executor_name'], executor[0]['executor_version']).subscribe(data => {
            if (data) {
                executor2 = data;
                if (executor2.hasOwnProperty('mockResponses')) {
                    executor2['mockResponses'] = item.mockResponses;
                }

                const dialogRef = this.dialog.open(ResponseSettingsComponent, {
                    width: '80%',
                    height: '80%',
                    data: {executor: executor2}
                });


                dialogRef.afterClosed().subscribe(async result => {

                    this.confPost.updateApiExecutorForPartnerAccount(this.partner, this.partner, executor2['id'], executor2).subscribe(res => {
                        if (res) {
                            // console.log('updated api = ', res);
                        }
                    });
                });
            }
        });

    }
}
